<template>
	<div>
		<!-- Title -->
		<div class="viewport-size" style="background-color: #F6F6F6; position:relative; z-index:-2">
			<div class="main-background-image-container_">
				<picture>
					<source class="main-background-image" media="(min-width:600px)" srcset="static/img/main-background.webp" type="image/webp" />
					<source class="main-background-image" media="(min-width:600px)" srcset="static/img/main-background.jp2" type="image/jp2" />
					<img class="main-background-image" src="about:blank" />
					<!-- <img class="main-background-image" src="static/img/main-background.webp" /> -->
				</picture>
			</div>
			<!-- <div class="main-background-image-blur" /> -->
			<h1 class="haqcs-heading-1">HAQCS</h1>
			<h2 class="haqcs-heading-2">Hapla Air Quality Control System.</h2>
			<picture>
				<source class="main-image" media="(min-width:600px)" srcset="static/haqcs-renderings/main.webp" type="image/webp" />
				<source class="main-image"  srcset="static/haqcs-renderings/main_800px.webp" type="image/webp" />
				<source class="main-image" srcset="static/haqcs-renderings/main.jp2" type="image/jp2" />
				<img class="main-image" src="static/haqcs-renderings/main.png" />
			</picture>
			<img class="main-image" />
		</div>

		<!-- The HAQCS is ... -->
		<div class="haqcs-is" ref="haqcs-is">
			<div class="container_ top">
				<div :class="[ showBothModes ? 'both' : 'single', 'flex-container_' ]">
					<div class="content content-heading" style="width:100%">
						<p class="heading">
							{{ lng.haqcsIs }}
						</p>
					</div>
					<div class="content content-seperator">
						<div class="tile separator-line" />
					</div>
					<div class="content content-as-controller">
						<div class="tile controller">
							<!-- <img src="../../static/img/haqcs-renderings/gray-auto.png" /> -->
							<picture>
								<source class="noselect haqcs" media="(min-width:800px)" srcset="static/img/haqcs-renderings/gray-auto_1046px.webp" type="image/webp" />
								<source class="noselect haqcs"                           srcset="static/img/haqcs-renderings/gray-auto_400px.webp" type="image/webp" />
								<img class="noselect haqcs" src="static/img/haqcs-renderings/gray-auto_min.png" />
							</picture>
							<p>{{ lng.aController }}</p>
						</div>
					</div>
					<div class="content content-as-monitor">
						<div class="tile monitor">
							<!-- <img src="../../static/img/haqcs-renderings/display/green-comfort.png" /> -->
							<picture>
								<source class="noselect haqcs" media="(min-width:800px)" srcset="static/img/haqcs-renderings/display/webp_1046px/green-comfort.webp" type="image/webp" />
								<source class="noselect haqcs"                           srcset="static/img/haqcs-renderings/display/webp_400px/green-comfort.webp" type="image/webp" />
								<img class="noselect haqcs" src="static/img/haqcs-renderings/display/png/green-comfort.png" />
							</picture>
							<p>{{ lng.aMonitor }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="background-color: #F6F6F6; padding-bottom: 10vh;" />
		<div style="background-color: rgb(253, 253, 253); padding-bottom: 5vh;" />

		<!-- HAQCS as a monitor. -->
		<div id="haqcs-as-a-monitor" ref="haqcs-as-a-monitor">
			<div :class="[ 'header-bar', 'top', (headerBarStickingMonitor) ? 'header-bar-sticking' : 'header-bar-not-sticking' ]">
				<div class="header-bar-container_">
					<h2 class="hidden-sm-and-down" style="margin:0;padding:0;line-height:5vh;">
						<span class="top-heading">{{ lng.haqcsAsA }}</span> <span class="top-heading top-heading-item" v-scroll-to="'#haqcs-as-a-monitor'">{{ lng.measuringDevice }}</span> <span class="top-heading top-heading-item top-heading-inactive" v-scroll-to="'#haqcs-as-a-controller'">{{ lng.controller }}</span><span class="top-heading">.</span>
					</h2>
					<div class="hidden-md-and-up">
						<span class="top-heading">{{ lng.haqcsAsA }} {{ lng.measuringDevice }}.</span>
					</div>
					<p class="top-paragraph">
						{{ lng.measuringDeviceTopParagraph }}
					</p>
				</div>
				<div :class="[ 'shadow', (headerBarStickingMonitor) ? 'shadow-visible' : 'shadow-invisible' ]" />
			</div>

			<div id="haqcs-as-a-monitor">
				<div class="vertical-dots-container_ top">
					<div class="centered-dots-container_">
						<div v-for="i in 3" :key="i"
						     :class="[ 'single-dot-container_',  (viewedSlide + 1) == i ? 'single-dot-container_-active' : '' ]"
							 v-scroll-to="'#slide_'+String(i-1)">
							<span :class="[ 'dot', (viewedSlide + 1) == i ? '' : 'dot-inactive' ]" />
						</div>
					</div>
				</div>
				<div style="margin-bottom:-100vh;"/>
				<div class="haqcs-display top" :style="{ transform: 'translateY('+haqcsOffset+'vh)' }" ref="haqcs-display">
					<div class="container_">
						<!-- <img src="../assets/haqcs-renderings/red-comfort.png"/> -->
						<div class="img-container_">
							<div v-for="color in [ 'red', 'green', 'gray' ]" :key="color">
								<div v-for="display in [ 'comfort', 'history' ]" :key="display">
									<!-- <img :src="'../../static/img/haqcs-renderings/display/png/'+color+'-'+display+'.png'"
									     :alt="color + ' HAQCS-Monitor showing the ' + display + ' display.'"
										 :class="[ (viewedHaqcsColor == color && viewedHaqcsDisplay == display) ? '' : 'inactive' ]" /> -->
									<picture>
										<source :class="[ (viewedHaqcsColor == color && viewedHaqcsDisplay == display) ? '' : 'inactive' ]" 
										         media="(min-width:800px)" :srcset="'static/img/haqcs-renderings/display/webp_1046px/'+color+'-'+display+'.webp'" type="image/webp" />
										<source :class="[ (viewedHaqcsColor == color && viewedHaqcsDisplay == display) ? '' : 'inactive' ]" 
										                                   :srcset="'static/img/haqcs-renderings/display/webp_400px/'+color+'-'+display+'.webp'" type="image/webp" />
										<img :class="[ (viewedHaqcsColor == color && viewedHaqcsDisplay == display) ? '' : 'inactive' ]" 
										     :src="'../../static/img/haqcs-renderings/display/png/'+color+'-'+display+'.png'" />
									</picture>
								</div>
							</div>
							<!-- <img :src="'../../static/img/haqcs-renderings/display/'+viewedHaqcsColor+'-'+viewedHaqcsDisplay+'.png'" 
							     style="opacity: 1.0;position: relative; z-index:-1;"/> -->
							<picture>
								<source style="opacity: 1.0;position: relative; z-index:-1;"
											media="(min-width:800px)" :srcset="'static/img/haqcs-renderings/display/webp_1046px/'+viewedHaqcsColor+'-'+viewedHaqcsDisplay+'.webp'" type="image/webp" />
								<source style="opacity: 1.0;position: relative; z-index:-1;"
																	  :srcset="'static/img/haqcs-renderings/display/webp_400px/'+viewedHaqcsColor+'-'+viewedHaqcsDisplay+'.webp'" type="image/webp" />
								<img style="opacity: 1.0;position: relative; z-index:-1;"
										:src="'../../static/img/haqcs-renderings/display/png/'+viewedHaqcsColor+'-'+viewedHaqcsDisplay+'.png'" />
							</picture>
						</div>
						<!-- <img :src="'../../static/img/haqcs-renderings/display/'+viewedHaqcsColor+'-'+viewedHaqcsDisplay+'.png'" /> -->
						<!-- <img src="../../static/img/haqcs-renderings/display/red-comfort.png" /> -->
						<div class="color-selector">
							<span v-for="c in colors" :key="c[0]"
								  :class="[ (c[0] == selectedColor) ? 'active' : 'inactive' ]"
								  @click="selectedColor = c[0]">
								<span class="bead"
								      :style="{ background:'linear-gradient(to bottom,'+c[1]+','+c[c[0] == selectedColor ? 2 : 1]+')' }">
									<span :class="[ c[0] == selectedColor ? '' : 'invisible' ]" class="shiny" />
								</span>
							</span>
						</div>
						<p :class="[ viewedSlide == 2 ? 'invisible' : '' ]" style="position:absolute">
							<span v-html="lng.historyDisplay" />
						</p>
						<p :class="[ viewedSlide == 2 ? '' : 'invisible' ]">
							<span v-html="lng.comfortDisplay" />
						</p>
					</div>
				</div>
				<div style="margin-bottom:-100vh;" class="hidden-sm-and-down"/>
				<div class="slide slide0" ref="slide_0" id="slide_0">
					<p :class="[ 'text', (viewedSlide == 0) ? '' : 'text-not-viewed' ]" ref="slideText_0">
						<b>{{ lng.slideText[0][0] }}</b> <br>
						<span v-html="lng.slideText[0][1]" />
					</p>
				</div>
				<div class="slide slide1" ref="slide_1" id="slide_1">
					<p :class="[ 'text', (viewedSlide == 1) ? '' : 'text-not-viewed' ]" ref="slideText_1">
						<b>{{ lng.slideText[1][0] }}</b> <br>
						<span v-html="lng.slideText[1][1]" />
					</p>
				</div>
				<div class="slide slide2" ref="slide_2" id="slide_2">
					<p :class="[ 'text', (viewedSlide == 2) ? '' : 'text-not-viewed' ]" ref="slideText_2">
						<b>{{ lng.slideText[2][0] }}</b> <br>
						<span v-html="lng.slideText[2][1]" />
					</p>
				</div>
				<div class="slide3" ref="slide_3" /> <!-- empty slide, required to make the scroll detection work -->
			</div>
			<div class="img-slide">
				<div class="img">
					<!-- <img src="static/parallax.jpg" class="button-card-img"/> -->
					<!-- <img class="button-card-img noselect" src="static/haqcs_transparent.png"/> -->
					<!-- <img class="button-card-img noselect" src="../assets/haqcs-photos/leds.jpg"/> -->
					<picture>
						<source class="button-card-img noselect" media="(min-width:600px)" srcset="static/img/haqcs-photos/leds_1024px.webp" />
						<source class="button-card-img noselect" media="(min-width:1024px)" srcset="static/img/haqcs-photos/leds_2000px.webp" />
						<source class="button-card-img noselect"                            srcset="static/img/haqcs-photos/leds_800px.webp" loading="lazy" />
						<img class="button-card-img noselect" src="static/img/haqcs-photos/leds.jpg" loading="lazy"/>
					</picture>
				</div>
				<div class="text-background" />
				<div class="text-background-fade" />
				<div class="text-container_">
					<p class="text">
						{{ lng.photoTextLED }}
					</p>
					<picture>
						<source class="small-image hidden-md-and-up" media="(max-width:800px)" srcset="static/img/haqcs-photos/leds_small_800px.webp" type="image/webp" />
						<source class="small-image hidden-md-and-up" media="(max-width:1023px)" srcset="static/img/haqcs-photos/leds_small_1024px.webp" type="image/webp" />
						<source class="small-image hidden-md-and-up" srcset="about:blank" type="image/webp" />
						<img class="small-image hidden-md-and-up" src="static/img/haqcs-photos/leds.jpg" />
					</picture>
				</div>
			</div>
			<div class="img-slide img-slide-dark">
				<div class="img">
					<!-- <img src="static/parallax.jpg" class="button-card-img"/> -->
					<picture>
						<source class="button-card-img noselect" media="(min-width:600px)" srcset="static/img/haqcs-photos/alarms_1024px.webp" />
						<source class="button-card-img noselect" media="(min-width:1024px)" srcset="static/img/haqcs-photos/alarms_2000px.webp" />
						<source class="button-card-img noselect"                            srcset="static/img/haqcs-photos/alarms_800px.webp" loading="lazy" />
						<img class="button-card-img noselect" src="static/img/haqcs-photos/alarms.jpg" loading="lazy"/>
					</picture>
				</div>
				<div class="text-background" />
				<div class="text-background-fade" />
				<div class="text-container_">
					<p class="text">
						{{ lng.photoTextAlarms }}
					</p>
					<!-- <img class="hidden-md-and-up small-image" src="../assets/haqcs-photos/alarms.jpg"/> -->
					<picture>
						<source class="small-image hidden-md-and-up" media="(max-width:800px)" srcset="static/img/haqcs-photos/alarms_small_800px.webp" type="image/webp" />
						<source class="small-image hidden-md-and-up" media="(max-width:1023px)" srcset="static/img/haqcs-photos/alarms_small_1024px.webp" type="image/webp" />
						<source class="small-image hidden-md-and-up" srcset="about:blank" type="image/webp" />
						<img class="small-image hidden-md-and-up" src="static/img/haqcs-photos/alarms.jpg" />
					</picture>
				</div>
			</div>
		</div>

		<div style="background-color: rgb(253, 253, 253); padding-bottom: 15vh;" />

		<!-- HAQCS as a controller -->
		<div id="haqcs-as-a-controller" ref="haqcs-as-a-controller">
			<div :class="[ 'header-bar', 'top', (headerBarStickingController) ? 'header-bar-sticking' : 'header-bar-not-sticking' ]">
				<div class="header-bar-container_">
					<h2 class="hidden-sm-and-down" style="margin:0;padding:0;line-height:5vh;">
						<span class="top-heading">{{ lng.haqcsAsA }}</span> <span class="top-heading top-heading-item top-heading-inactive" v-scroll-to="'#haqcs-as-a-monitor'">{{ lng.measuringDevice }}</span> <span class="top-heading top-heading-item" v-scroll-to="'#haqcs-as-a-controller'">{{ lng.controller }}</span><span class="top-heading">.</span>
					</h2>
					<div class="hidden-md-and-up">
						<span class="top-heading">{{ lng.haqcsAsA }} {{ lng.controller }}.</span>
					</div>
					<p class="top-paragraph">
						{{ lng.controllerTopParagraph }}
					</p>
				</div>
				<div :class="[ 'shadow', (headerBarStickingController) ? 'shadow-visible' : 'shadow-invisible' ]" />
			</div>

			<div class="image-of-haqcs">
				<picture>
					<source class="noselect dev0" srcset="static/img/devices/webp/0.webp" type="image/webp" />
					<source class="noselect dev0" srcset="static/img/devices/jp2/0.jp2" type="image/jp2" />
					<img class="noselect dev0" src="static/img/devices/webp/0.webp">
				</picture>
				<picture>
					<source class="noselect dev0" srcset="static/img/devices/webp/1.webp" type="image/webp" />
					<source class="noselect dev0" srcset="static/img/devices/jp2/1.jp2" type="image/jp2" />
					<img class="noselect dev1" src="static/img/devices/webp/1.webp">
				</picture>
				<picture>
					<source class="noselect dev0" srcset="static/img/devices/webp/2.webp" type="image/webp" />
					<source class="noselect dev0" srcset="static/img/devices/jp2/2.jp2" type="image/jp2" />
					<img class="noselect dev2" src="static/img/devices/webp/2.webp">
				</picture>
				<picture>
					<source class="noselect haqcs" media="(min-width:800px)" srcset="static/img/haqcs-renderings/gray-auto_1046px.webp" type="image/webp" />
					<source class="noselect haqcs"                           srcset="static/img/haqcs-renderings/gray-auto_400px.webp" type="image/webp" />
					<img class="noselect haqcs" src="static/img/haqcs-renderings/gray-auto_min.png" />
				</picture>
				<picture>
					<source class="noselect dev0" srcset="static/img/devices/webp/3.webp" type="image/webp" />
					<source class="noselect dev0" srcset="static/img/devices/jp2/3.jp2" type="image/jp2" />
					<img class="noselect dev3" src="static/img/devices/webp/3.webp">
				</picture>
				<picture>
					<source class="noselect dev0" srcset="static/img/devices/webp/4.webp" type="image/webp" />
					<source class="noselect dev0" srcset="static/img/devices/jp2/4.jp2" type="image/jp2" />
					<img class="noselect dev4" src="static/img/devices/webp/4.webp">
				</picture>
				<picture>
					<source class="noselect dev0" srcset="static/img/devices/webp/5.webp" type="image/webp" />
					<source class="noselect dev0" srcset="static/img/devices/jp2/5.jp2" type="image/jp2" />
					<img class="noselect dev-2" src="static/img/devices/webp/5.webp">
				</picture>
				<picture>
					<source class="noselect dev0" srcset="static/img/devices/webp/6.webp" type="image/webp" />
					<source class="noselect dev0" srcset="static/img/devices/jp2/6.jp2" type="image/jp2" />
					<img class="noselect dev-1" src="static/img/devices/webp/6.webp">
				</picture>
			</div>

			<div class="explanation">
				<div class="tile tile0">
					<img class="bg-icon" src="../../static/img/icons/icon_cpu.svg" loading="lazy" />
					<div class="tile-content">
						<div class="container_">
							<div class="text">
								<p>
									{{ lng.explanationModes }}
								</p>
							</div>
							<div class="images">
								<img class="img0" src="../assets/haqcs-as-a-controller-images/top-strip/0.png" loading="lazy" />
								<img class="img1" src="../assets/haqcs-as-a-controller-images/top-strip/1.png" loading="lazy" />
								<img class="img2" src="../assets/haqcs-as-a-controller-images/top-strip/2.png" loading="lazy" />
								<img class="img3" src="../assets/haqcs-as-a-controller-images/top-strip/3.png" loading="lazy" />
								<img class="img4" src="../assets/haqcs-as-a-controller-images/top-strip/4.png" loading="lazy" />
							</div>
						</div>
					</div>
				</div>
				<div class="tile tile1">
					<img class="bg-icon" src="../../static/img/icons/icon_gear.svg" loading="lazy" />
					<div class="tile-content">
						<div class="container_">
							<div class="text">
								<p>
									<span v-html="lng.explanationWeighting" />
								</p>
							</div>
							<div class="images">
								<img class="no-shadow" src="../assets/haqcs-as-a-controller-images/weighting.svg" loading="lazy" />
							</div>
						</div>
					</div>
				</div>
				<div class="tile tile2">
					<img class="bg-icon" src="../../static/img/icons/icon_fan.svg" loading="lazy" />
					<div class="tile-content">
						<div class="container_">
							<div class="text">
								<p>
									{{ lng.explanationStormMode }}
								</p>
							</div>
							<div class="images">
								<img src="../assets/haqcs-as-a-controller-images/storm_mode.png" loading="lazy" />
							</div>
						</div>
					</div>
				</div>
				<div class="tile tile3">
					<img class="bg-icon" src="../../static/img/icons/icon_snowflake.svg" loading="lazy" />
					<div class="tile-content">
						<div class="container_">
							<div class="text">
								<p>
									{{ lng.explanationSummerMode }}
								</p>
							</div>
							<div class="images">
								<!-- <img src="../assets/haqcs-as-a-controller-images/Sommerbetrieb.png"/> -->
								<picture>
									<source srcset="static/img/haqcs-as-a-controller-images/Sommerbetrieb.webp" type="image/webp" />
									<img src="static/img/haqcs-as-a-controller-images/Sommerbetrieb.jpg" loading="lazy" />
								</picture>
							</div>
						</div>
					</div>
				</div>
				<div class="tile tile4">
					<img class="bg-icon" src="../../static/img/icons/icon_drops.svg" loading="lazy" />
					<div class="tile-content">
						<p class="center">
							{{ lng.explanationHumidityThreshold }}
						</p>
					</div>
				</div>
			</div>

			<div class="paragraph-container_">
				<p class="paragraph">
					{{ lng.pCompatible }}
				</p>

				<div class="spacer" />

				<div v-if="language === 'pl'">
					<h3 class="paragraph bold">1. Marley MEnV HAQCS Edition</h3>
					<div class="paragraph">	
						<div class="flex-container_">
							<div>
								<!-- <img class="elevation-2" src="static/img/homepage-devices/marley-kit.jpg" /> -->
								<picture>
									<source media="(min-width:3000px)" srcset="static/img/homepage-devices/marley-haqcs-edition_1041px.webp" type="image/webp" />
									<source media="(min-width:1024px)" srcset="static/img/homepage-devices/marley-haqcs-edition_1024px.webp" type="image/webp" />
									<source                            srcset="static/img/homepage-devices/marley-haqcs-edition_800px.webp" type="image/webp" />
									<img src="static/img/homepage-devices/marley-haqcs-edition.jpg" loading="lazy" />
								</picture>
							</div>
			
							<p>
								<span v-html="lng.marleyMEnV180IIHAQCSEditionString" />
							</p>
						</div>
					</div>

					<div class="spacer" />
				</div>
	
				<h3 class="paragraph bold">{{ language === 'pl' ? '2' : '1' }}. Alnor HRU-WALL-WI</h3>
				<div class="paragraph">	
					<div class="flex-container_">
						<div>
							<picture>
								<source media="(min-width:3000px)" srcset="static/img/homepage-devices/alnor-hru-wall-wi_1600px.webp" type="image/webp" />
								<source media="(min-width:1024px)" srcset="static/img/homepage-devices/alnor-hru-wall-wi_1024px.webp" type="image/webp" />
								<source                            srcset="static/img/homepage-devices/alnor-hru-wall-wi_800px.webp" type="image/webp" />
								<img src="static/img/homepage-devices/alnor-hru-wall-wi.jpg" loading="lazy" />
							</picture>
						</div>
		
						<p>
							<span v-html="lng.alnorHRUWALLString" />
						</p>
					</div>
				</div>

				<div class="spacer" />
				
				<h3 class="paragraph bold">{{ language === 'pl' ? '3' : '2' }}. Marley MEnV 180</h3>
				<div class="paragraph">	
					<div class="flex-container_">
						<div>
							<!-- <img class="elevation-2" src="static/img/homepage-devices/marley-kit.jpg" /> -->
							<picture>
								<source class="elevation-2" media="(min-width:3000px)" srcset="static/img/homepage-devices/marley-kit_1600px.webp" type="image/webp" />
								<source class="elevation-2" media="(min-width:1024px)" srcset="static/img/homepage-devices/marley-kit_1024px.webp" type="image/webp" />
								<source class="elevation-2"                            srcset="static/img/homepage-devices/marley-kit_800px.webp" type="image/webp" />
								<img class="elevation-2" src="static/img/homepage-devices/marley-kit.jpg" loading="lazy" />
							</picture>
						</div>
		
						<p>
							<span v-html="lng.marleyMEnV180String" />
						</p>
					</div>
				</div>

				<div class="spacer" />
	
				<h3 class="paragraph bold">{{ language === 'pl' ? '4' : '3' }}. Prana 150 {{ lng.and }} 200 C / G</h3>
				<div class="paragraph">	
					<div class="flex-container_">
						<div>
							<!-- <img class="elevation-2" src="static/img/homepage-devices/prana-kit.jpg" /> -->
							<picture>
								<source class="elevation-2" media="(min-width:3000px)" srcset="static/img/homepage-devices/prana-kit_1600px.webp" type="image/webp" />
								<source class="elevation-2" media="(min-width:1024px)"  srcset="static/img/homepage-devices/prana-kit_1024px.webp" type="image/webp" />
								<source class="elevation-2"                            srcset="static/img/homepage-devices/prana-kit_800px.webp" type="image/webp" />
								<img class="elevation-2" src="static/img/homepage-devices/prana-kit.jpg" loading="lazy" />
							</picture>
						</div>
		
						<p>
							<span v-html="lng.prana150String" />
						</p>
					</div>
				</div>

				<div class="spacer" />
	
				<h3 class="paragraph bold">{{ language === 'pl' ? '5' : '4' }}. {{ lng.simpleFans }}</h3>
				<div class="paragraph">
					<div class="flex-container_">
						<div>
							<!-- <img src="static/img/homepage-devices/unibox.jpg" /> -->
							<picture>
								<source srcset="static/img/homepage-devices/unibox.webp" type="image/webp" />
								<img src="static/img/homepage-devices/unibox.jpg" loading="lazy" />
							</picture>
						</div>
		
						<p>
							{{ lng.simpleString }}
						</p>
					</div>
				</div>

				<div class="spacer" />
			</div>
		</div>

		<!-- <div class="kickstarter" v-if="language !== 'pl'">
			{{ lng.kickstarter }}
			<div class="button noselect">
				{{ lng.kickstarterSupport }}
			</div>
		</div> -->

		<!-- button cards -->
		<!-- <div class="viewport-size" style="background-color: #EFEFEF">
			<p class="haqcs-heading-3">
				Der HAQCS-Monitor ist ...
			</p>
			<br>
			<div class="button-container_">
				<v-container_ grid-list-xs fluid>
					<v-layout row wrap>
						<v-flex xs12 md5 style="height:100%">
							<v-card hover class="button-card" v-scroll-to="'#monitor'">
								<img src="static/haqcs_transparent.png" class="button-card-img"/>
								<span class="text"> ein Messgerät der Luftqualität und des Raumklimas. </span>
							</v-card>
						</v-flex>
						<v-flex xs2 style="height:100%">
							<div class="separator-container_">
								<img src="static/button_separator.svg" class="hidden-sm-and-down" />
							</div>
						</v-flex>
						<v-flex xs12 md5 style="height:100%">
							<v-card hover class="button-card" v-scroll-to="'#controller'">
								<img src="static/parallax.jpg" class="button-card-img"/>
								<span class="text"> ein Regler für Lüftung und Befeuchtung. </span>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container_>
			</div>
		</div> -->

		<!-- HAQCS as a monitor carousell. -->
		<!-- <div class="viewport-size" style="background-color: #23324B" id="monitor">
			<div class="carousell-bottom-bar-container_">
				<div class="carousell-bottom-bar">
					<span v-for="slide in slides[0]" :key="slide[0]" :class="[ 'dot-container_', (slide[0] == currentSlide[0]) ? 'dot-container_-active' : 'dot-container_-inactive' ]" @click="() => { gotoSlide(0, slide[0]); }">
						<span class="dot dot-light"/>
					</span>
				</div>
			</div>
			<div v-for="slide in slides[0]" :key="slide[0]">
				<transition name="fade">
					<img v-if="slide[0] == currentSlide[0]" :src="slide[1]" class="button-card-img noselect"/>
				</transition>
			</div>
			<div class="carousell-icon-container_">
				<div :class="[ 'slim-container_', 'slim-container_-left', (currentSlide[0] == 0) ? 'slim-container_-disabled' : 'slim-container_-bright' ]" @click="() => { prevSlide(0); }">
					<v-icon dark :class="[ 'noselect', 'carousell-icon', 'carousell-icon-left', (currentSlide[0] == 0) ? 'carousell-icon-disabled' : 'carousell-icon-clickable' ]">chevron_left</v-icon>
				</div>
				<div :class="[ 'slim-container_', 'slim-container_-right', (currentSlide[0] == slides[0].length - 1) ? 'slim-container_-disabled' : 'slim-container_-bright' ]" @click="() => { nextSlide(0); }">
					<v-icon dark :class="[ 'noselect', 'carousell-icon', 'carousell-icon-right', (currentSlide[0] == slides[0].length - 1) ? 'carousell-icon-disabled' : 'carousell-icon-clickable' ]">chevron_right</v-icon>
				</div>
			</div>
			<h3 class="haqcs-heading-4 text-over-button-card-img">Der HAQCS-Monitor als Messgerät.</h3>
			<div v-for="slide in slides[0]" :key="slide[0]" class="text-over-button-card-img-container_">
				<transition name="slide-animation">
					<div v-if="slide[0] == currentSlide[0]">
						<p class="haqcs-heading-4-text text-over-button-card-img">{{ slide[2] }}</p>
						<div v-if="slide.length > 3" class="carousell-learn-more-button-container_">
							<router-link :to="'/docs/' + slide[4]">
								<span class="button button-light button-font-size noselect"> {{ slide[3] }} </span>
							</router-link>
						</div>
					</div>
				</transition>
			</div>
		</div> -->

		<!-- HAQCS as a controller carousell. -->
		<!-- <div class="viewport-size" style="background-color: #FDFDFD" id="controller">
			<div class="carousell-bottom-bar-container_">
				<div class="carousell-bottom-bar">
					<span v-for="slide in slides[1]" :key="slide[0]" :class="[ 'dot-container_', (slide[0] == currentSlide[1]) ? 'dot-container_-active' : 'dot-container_-inactive' ]" @click="() => { gotoSlide(1, slide[0]); }">
						<span class="dot dot-dark"/>
					</span>
				</div>
			</div>
			<div v-for="slide in slides[1]" :key="slide[0]">
				<transition name="fade">
					<img v-if="slide[0] == currentSlide[1]" :src="slide[1]" class="button-card-img noselect"/>
				</transition>
			</div>
			<div class="carousell-icon-container_">
				<div :class="[ 'slim-container_', 'slim-container_-left', (currentSlide[1] == 0) ? 'slim-container_-disabled' : 'slim-container_-dark' ]" @click="() => { prevSlide(1); }">
					<v-icon light :class="[ 'noselect', 'carousell-icon', 'carousell-icon-left', (currentSlide[1] == 0) ? 'carousell-icon-disabled' : 'carousell-icon-clickable' ]">chevron_left</v-icon>
				</div>
				<div :class="[ 'slim-container_', 'slim-container_-right', (currentSlide[1] == slides[1].length - 1) ? 'slim-container_-disabled' : 'slim-container_-dark' ]" @click="() => { nextSlide(1); }">
					<v-icon light :class="[ 'noselect', 'carousell-icon', 'carousell-icon-right', (currentSlide[1] == slides[1].length - 1) ? 'carousell-icon-disabled' : 'carousell-icon-clickable' ]">chevron_right</v-icon>
				</div>
			</div>
			<h3 class="haqcs-heading-5 text-over-button-card-img">Der HAQCS-Monitor als Regler.</h3>
			<div v-for="slide in slides[1]" :key="slide[0]" class="text-over-button-card-img-container_">
				<transition name="slide-animation">
					<div v-if="slide[0] == currentSlide[1]">
						<p class="haqcs-heading-5-text text-over-button-card-img">{{ slide[2] }}</p>
						<div v-if="slide.length > 3" class="carousell-learn-more-button-container_">
							<router-link :to="'/docs/' + slide[4]">
								<span class="button button-dark button-font-size noselect"> {{ slide[3] }} </span>
							</router-link>
						</div>
					</div>
				</transition>
			</div>
		</div> -->

		<!-- DEPRECATED -->
		<!-- carousell  -->
		<!-- <v-card class="hidden-sm-and-down">
			<div class="image-container_">
				<div style="position:relative; width:1800px; padding-bottom:39%" class="auto-scale">
					<div v-for="image in lng.images" :key="image.n">
						<transition name="fade">
							<div v-if="image.n === currentImage">
								<img v-bind:src="image.url" style="position:absolute" class="auto-scale">
							</div>
						</transition>
						<div class="after" v-on:mouseover="showOverlay = true" v-on:touchstart="showOverlay = true">
							<transition name="slide-fade-right">
								<div v-if="image.n === currentImage && showOverlay">
									<img v-bind:src="image.overlay" class="auto-scale">
								</div>
							</transition>
						</div>
					</div>
					<v-progress-linear v-if="lng.images.length > 1" v-model="progressTillNextImage" height=4 color-front="blue" color-back="blue lighten-5"></v-progress-linear>
				</div>
			</div>
		</v-card> -->

		<!-- product descriptions -->
		<!-- <v-container_ style="max-width:1024px"> -->
			<!-- <v-card style="padding: 8px 16px;"> -->
				<!-- <h1 class="heading-big black--text text-xs-center" style="padding-bottom:8px">{{ lng.title }}</h1> -->
<!--  -->
				<!-- <v-layout row-sm column wrap> -->
					<!-- 1  -->
					<!-- <v-flex order-xs1 order-sm1> -->
						<!-- <h2 class="heading-big black--text" style="padding-right:8px"> -->
							<!-- {{ lng.pranaTitle }} <img src="../../static/img/logo/prana_small.jpg" alt="Prana" class="auto-downscale"/> -->
						<!-- </h2> -->
					<!-- </v-flex> -->
<!--  -->
					<!-- 4 -->
					<!-- <v-flex order-xs5 order-sm2> -->
						<!-- <div class="hidden-sm-and-up"> -->
							<!-- <div class="spacing-32"/> -->
							<!-- <v-divider/> -->
						<!-- </div> -->
						<!-- <div class="hidden-sm-and-up" style="padding-top:64px"/> -->
						<!-- <h2 class="heading-big black--text" style="padding-left:8px"> -->
							<!-- {{ lng.solarfoxTitle }} <img src="../../static/img/logo/solar-fox_small.png" alt="Solar Fox" class="auto-downscale"/> -->
						<!-- </h2> -->
					<!-- </v-flex> -->
<!--  -->
					<!-- <v-flex xs12 order-xs3 order-sm3/> -->
<!--  -->
					<!-- 2  -->
					<!-- <v-flex order-xs2 order-sm4> -->
						<!-- <img v-bind:src="pranaImg" class="auto-downscale img-center"/><br><br><br> -->
						<!-- <h3 style="font-size:24px" class="heading black--text"> -->
							<!-- {{ lng.pranaSubtitle }} -->
						<!-- </h3> -->
						<!-- <div style="padding-right:8px" class="long-text grey--text text--darken-1"> -->
							<!-- {{ lng.pranaBody }} -->
						<!-- </div> -->
					<!-- </v-flex> -->
<!--  -->
					<!-- 5 -->
					<!-- <v-flex order-xs7 order-sm5> -->
						<!-- <img v-bind:src="solarfoxImg" class="auto-downscale img-center"/><br><br><br> -->
						<!-- <h3 style="font-size:24px; padding-left:8px" class="heading black--text"> -->
							<!-- {{ lng.solarfoxSubtitle }} -->
						<!-- </h3> -->
						<!-- <div style="padding-left:8px" class="long-text grey--text text--darken-1"> -->
							<!-- {{ lng.solarfoxBody }} -->
						<!-- </div> -->
					<!-- </v-flex> -->
<!--  -->
					<!-- <v-flex xs12 order-xs6 order-sm6/> -->
<!--  -->
					<!-- 3 -->
					<!-- <v-flex order-xs4 order-sm7> -->
						<!-- <div style="padding-left: 64px; padding-right: 64px; padding-top: 12px"> -->
							<!-- <router-link :to="lng.linkPrana"> -->
								<!-- <v-btn block v-tooltip:top="{ html: lng.moreTooltip }" class="accent"> -->
									<!-- <span>{{ lng.more }}</span> -->
								<!-- </v-btn> -->
							<!-- </router-link> -->
						<!-- </div> -->
					<!-- </v-flex> -->
<!--  -->
					<!-- 6 -->
					<!-- <v-flex order-xs8 order-sm8> -->
						<!-- <div style="padding-left: 64px; padding-right: 64px; padding-top: 12px"> -->
							<!-- <router-link :to="lng.linkSolarfox"> -->
								<!-- <v-btn block v-tooltip:top="{ html: lng.moreTooltip }" class="accent"> -->
									<!-- <span>{{ lng.more }}</span> -->
								<!-- </v-btn> -->
							<!-- </router-link> -->
						<!-- </div> -->
					<!-- </v-flex> -->
				<!-- </v-layout> -->
<!--  -->
				<!-- TEMP: remove the span after translating Termofol -->
				<!-- <span v-if="language === 'de'"> -->
					<!-- <div class="spacing-32"/> -->
					<!-- <v-divider/> -->
					<!-- <div class="spacing-32"/> -->
<!--  -->
					<!-- <v-flex order-xs1 order-sm1> -->
						<!-- <h2 class="heading-big black--text" style="padding-right:8px"> -->
							<!-- {{ lng.termofolTitle }} <img src="../../static/img/logo/termofol_small.png" alt="Termofol" class="auto-downscale"/> -->
						<!-- </h2> -->
					<!-- </v-flex> -->
					<!-- <v-layout row-md column> -->
						<!-- <v-flex> -->
							<!-- <img v-bind:src="termofolImg" class="auto-downscale img-center elevation-4"/><br><br><br> -->
						<!-- </v-flex> -->
						<!-- <v-flex> -->
							<!-- <div style="padding-left:8px" class="long-text grey--text text--darken-1 pre-wrap">{{ lng.termofolBody }}</div> -->
						<!-- </v-flex> -->
					<!-- </v-layout> -->
					<!-- <div style="padding-left: 64px; padding-right: 64px"> -->
						<!-- <router-link to="/funktionsweise-termofol"> -->
							<!-- <v-btn block v-tooltip:top="{ html: lng.moreTooltip }" class="accent"> -->
								<!-- <span>{{ lng.more }}</span> -->
							<!-- </v-btn> -->
						<!-- </router-link> -->
					<!-- </div> -->
				<!-- </span> -->
			<!-- </v-card> -->
		<!-- </v-container_> -->


		<!-- 3 props  -->
		<!-- <div v-on:mouseover="showProps = true" v-on:touchmove="showProps = true"> -->
			<!-- <v-parallax v-bind:src="parallaxImg" height=256> -->
				<!-- <v-layout column row-md> -->
					<!-- <v-flex> -->
						<!-- <div style="height:85px"> -->
							<!-- <transition name="slide-fade-left"> -->
								<!-- <img v-if="showProps" src="../assets/3 props/innovativ.png" class="img-center auto-downscale"/> -->
								<!-- <div v-if="showProps" class="props"> -->
									<!-- <v-icon x-large dark>check</v-icon> -->
									<!-- {{ lng.prop1 }} -->
								<!-- </div> -->
							<!-- </transition> -->
						<!-- </div> -->
					<!-- </v-flex> -->
<!--  -->
					<!-- <v-flex> -->
						<!-- <div style="height:85px"> -->
							<!-- <transition name="slide-fade-left-slow"> -->
								<!-- <img v-if="showProps" src="../assets/3 props/gesunde Atmosphaere.png" class="img-center auto-downscale"/> -->
								<!-- <div v-if="showProps" class="props"> -->
									<!-- <v-icon x-large dark>check</v-icon> -->
									<!-- {{ lng.prop2 }} -->
								<!-- </div> -->
							<!-- </transition> -->
						<!-- </div> -->
					<!-- </v-flex> -->
<!--  -->
					<!-- <v-flex> -->
						<!-- <div style="height:85px"> -->
							<!-- <transition name="slide-fade-left-slower"> -->
								<!-- <img v-if="showProps" src="../assets/3 props/spart Energie.png" class="img-center auto-downscale"/> -->
								<!-- <div v-if="showProps" class="props"> -->
									<!-- <v-icon x-large dark>check</v-icon> -->
									<!-- {{ lng.prop3 }} -->
								<!-- </div> -->
							<!-- </transition> -->
						<!-- </div> -->
					<!-- </v-flex> -->
				<!-- </v-layout> -->
			<!-- </v-parallax> -->
		<!-- </div> -->

		<!-- contact data  -->
		<v-card tile class="grey lighten-3" style="padding: 8px 64px;">
			<v-layout column row-sm align-center>
				<v-flex sm4>
					<div style="min-height:124px">
						<div class="div-center">
							<span class="span-center">
								<p class="heading-big">
									{{ lng.contact }}
								</p>
								<p class="heading-big grey--text text--darken-2" style="font-size:24px">
									{{ lng.areYouInterested }}
								</p>
							</span>
						</div>
					</div>
				</v-flex>

				<v-flex sm4>
					<div style="height:124px">
						<div class="div-center-124 heading-big grey--text text--darken-2 hidden-xs-only">
							<span class="span-center">
								<v-icon>phone</v-icon><br>
								<p>+49 1522 8619 710</p>
							</span>
						</div>
						<div class="div-center-124 heading grey--text text--darken-2 hidden-sm-and-up">
							<span class="span-center">
								<v-icon>phone</v-icon><br>
								<p>+49 1522 8619 710</p>
							</span>
						</div>
					</div>
				</v-flex>

				<v-flex sm4>
					<div style="height:124px">
						<div class="div-center-124 heading-big grey--text text--darken-2 hidden-xs-only">
							<a href="mailto:info@hapla.eu" class="a-nocolor">
								<span class="span-center">
									<v-icon>mail</v-icon><br>
									<p>info@hapla.eu</p>
								</span>
							</a>
						</div>
						<div class="div-center-124 heading grey--text text--darken-2 hidden-sm-and-up">
							<a href="mailto:info@hapla.eu" class="a-nocolor">
								<span class="span-center">
									<v-icon>mail</v-icon><br>
									<p>info@hapla.eu</p>
								</span>
							</a>
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-card>

		<v-card tile v-on:mouseover="showProps = true" v-on:touchmove="showProps = true" class="grey lighten-2" style="padding: 8px 64px;">
			<div style="min-height:75px">
				<div class="grey--text text--darken-2">
					<div class="heading hidden-xs-only">
						{{ lng.contactFormNotice }}
					</div>
					<div class="heading-small hidden-sm-and-up">
						{{ lng.contactFormNotice }}
					</div>
					<div @click="scrollToTop">
						<router-link :to="lng.linkContact">
							<v-btn flat block>
								<v-icon left>mail</v-icon>
								{{ lng.openContactFormButton }}
							</v-btn>
						</router-link>
					</div>
				</div>
			</div>
		</v-card>

		<!-- <v-card tile v-on:mouseover="showProps = true" v-on:touchmove="showProps = true" class="grey lighten-3" style="padding: 8px 64px;">
			<v-layout column row-sm align-center>
				<v-flex sm4>
					<div style="min-height:124px">
						<transition name="slide-fade-left">
							<div v-if="showProps" class="div-center">
								<span class="span-center">
									<p class="heading-big">
										{{ lng.contact }}
									</p>
									<p class="heading-big grey--text text--darken-2" style="font-size:24px">
										{{ lng.areYouInterested }}
									</p>
								</span>
							</div>
						</transition>
					</div>
				</v-flex>

				<v-flex sm4>
					<div style="height:124px">
						<transition name="slide-fade-left-slow">
							<div v-if="showProps" class="div-center-124 heading-big grey--text text--darken-2 hidden-xs-only">
								<span class="span-center">
									<v-icon>phone</v-icon><br>
									<p>+49 1522 8619 710</p>
								</span>
							</div>
						</transition>
						<transition name="slide-fade-left-slow">
							<div v-if="showProps" class="div-center-124 heading grey--text text--darken-2 hidden-sm-and-up">
								<span class="span-center">
									<v-icon>phone</v-icon><br>
									<p>+49 1522 8619 710</p>
								</span>
							</div>
						</transition>
					</div>
				</v-flex>

				<v-flex sm4>
					<div style="height:124px">
						<transition name="slide-fade-left-slower">
							<div v-if="showProps" class="div-center-124 heading-big grey--text text--darken-2 hidden-xs-only">
								<a href="mailto:info@hapla.eu" class="a-nocolor">
									<span class="span-center">
										<v-icon>mail</v-icon><br>
										<p>info@hapla.eu</p>
									</span>
								</a>
							</div>
						</transition>
						<transition name="slide-fade-left-slower">
							<div v-if="showProps" class="div-center-124 heading grey--text text--darken-2 hidden-sm-and-up">
								<a href="mailto:info@hapla.eu" class="a-nocolor">
									<span class="span-center">
										<v-icon>mail</v-icon><br>
										<p>info@hapla.eu</p>
									</span>
								</a>
							</div>
						</transition>
					</div>
				</v-flex>
			</v-layout>
		</v-card>

		<v-card tile v-on:mouseover="showProps = true" v-on:touchmove="showProps = true" class="grey lighten-2" style="padding: 8px 64px;">
			<div style="min-height:75px">
				<transition name="slide-fade-left-even-slower">
					<div v-if="showProps" class="grey--text text--darken-2">
						<div class="heading hidden-xs-only">
							{{ lng.contactFormNotice }}
						</div>
						<div class="heading-small hidden-sm-and-up">
							{{ lng.contactFormNotice }}
						</div>
						<router-link :to="lng.linkContact">
							<v-btn flat block>
								<v-icon left>mail</v-icon>
								{{ lng.openContactFormButton }}
							</v-btn>
						</router-link>
					</div>
				</transition>
			</div>
		</v-card> -->
	</div>
</template>

<script>
export default {
	name: 'Home',
	created: function() {
		// this.checkLng();
		this.updateLng();

		// this.countdown();
		// setTimeout(() => { this.showOverlay = true; }, 1000);

		// // image quality
		// if(document.documentElement.clientWidth >= 1024) {
		// 	this.parallaxImg = "static/parallax.jpg";
		// 	setTimeout(() => { this.parallaxImg = "static/parallax.png"; }, 500);
		// } else {
		// 	this.parallaxImg = "static/parallax_low.jpg";
		// 	setTimeout(() => { this.parallaxImg = "static/parallax.jpg"; }, 500);
		// }

		// if(document.documentElement.clientWidth >= 512) {
		// 	this.pranaImg = "static/img/1.jpg";
		// 	this.solarfoxImg = "static/img/SF_Home1_2.jpg";
		// 	this.termofolImg = "static/img/termofol.jpg";
		// } else {
		// 	this.pranaImg = "static/img/1_small.jpg";
		// 	this.solarfoxImg = "static/img/SF_Home1_2_small.jpg";
		// 	this.termofolImg = "static/img/termofol_small.jpg";
		// }
	},
	mounted: function() {
		this.unwatchLanguage = this.$watch('language', this.updateLng);
		
		this.checkScrollPositionInterval = setInterval(() => { this.checkScrollPosition(); }, 20);
		this.handleScrollBound = this.handleScroll.bind(this);
		document.getElementById('frame').addEventListener('scroll', this.handleScrollBound);
		// this.checkLngInterval = setInterval(() => { this.checkLng(); }, 5);
	},
	beforeDestroy() {
		clearInterval(this.checkScrollPositionInterval);
		document.getElementById('frame').removeEventListener('scroll', this.handleScrollBound);
		// clearInterval(this.checkLngInterval);
		this.unwatchLanguage();
	},
	data () {
		return {
			showBothModes: false,

			selectedColor: 0,
			colors: [
				[
					0, "rgb(195, 0, 0)", "rgb(123, 0, 0)"
				],
				[
					1, "rgb(0, 176, 0)", "rgb(0, 92, 0)"
				],
				[
					2, "rgb(128, 128, 128)", "rgb(64, 64, 64)"
				],
			],

			viewedHaqcsDisplay: 'comfort',
			viewedHaqcsColor: 'red',

			viewedSlide: 0,
			headerBarStickingMonitor: false,
			headerBarStickingController: false,
			haqcsOffset: 0,

			checkScrollPositionInterval: -1,
			checkScrollPosition: function() {
				if (typeof(this.checkScrollPosition.lastFromTop) == 'undefined') {
					this.checkScrollPosition.lastFromTop = fromTop;
				}

				// let fromTop = window.scrollY;
				let fromTop = document.getElementById('frame').scrollTop;

				if (fromTop == this.checkScrollPosition.lastFromTop) {
					return;
				}
				this.checkScrollPosition.lastReference = fromTop;

				const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
				const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

				// if (this.$refs.comfortSlide != 'undefined') {
				// 	this.viewedHaqcsDisplay = (this.$refs.comfortSlide.offsetTop > fromTop + (vh * 0.5)) ? 'history' : 'comfort';
				// }

				this.checkViewedSlide(fromTop, vh, vw);
				this.setViewedHAQCS();
				this.checkHeaderBarSticking(fromTop, vh);
				this.checkShowBothMods(fromTop, vh);
			},
			checkViewedSlide: function(fromTop, vh, vw) {
				let prev = 0;
				for (let i = 0; i < 4; ++i) {
					// let referenceString = (vw >= 1024 || i != 2) ? 'slide_' + String(i) : 'haqcs-display';
					let referenceString = 'slide_' + String(i);
					let ref = this.$refs[referenceString]
					// if (ref.offsetTop > fromTop + (0.5 * vh)) {
					if (ref.offsetTop > fromTop + (0.5 * ref.clientHeight)) {
						this.viewedSlide = prev;
						return;
					}
					prev = i;
				}
			},
			setViewedHAQCS: function() {
				this.viewedHaqcsDisplay = (this.viewedSlide == 2) ? 'comfort' : 'history';
				this.viewedHaqcsColor = this.selectedColor == 0 ? 'red' :
										this.selectedColor == 1 ? 'green' :
										                          'gray';
			},
			checkHeaderBarSticking: function(fromTop, vh) {
				{
					let ref = this.$refs["haqcs-as-a-monitor"];
					if (ref.offsetParent == null) return;

					let pos = ref.offsetTop;
					this.headerBarStickingMonitor = pos < fromTop;
				}

				{
					let ref = this.$refs["haqcs-as-a-controller"];
					if (ref.offsetParent == null) return;

					let pos = ref.offsetTop;
					this.headerBarStickingController = pos < fromTop;
				}
			},
			checkShowBothMods: function(fromTop, vh) {
				{
					let ref = this.$refs["haqcs-is"];
					if (ref.offsetParent == null) return;

					let pos = ref.offsetTop;
					this.showBothModes = pos < fromTop;
				}
			},
			map: function(x,  in_min,  in_max,  out_min,  out_max) {
				return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
			},
			handleScroll: function() {
				// let fromTop = window.scrollY;
				let fromTop = document.getElementById('frame').scrollTop;

				if (typeof(this.handleScrollBound.lastFromTop) == 'undefined') {
					this.handleScrollBound.lastFromTop = fromTop;
				}

				const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

				let force = Math.abs(this.handleScrollBound.lastFromTop - fromTop) > vh;

				let ref = this.$refs["haqcs-as-a-monitor"];
				if (ref.offsetParent == null) return;
				let pos = ref.offsetTop;
				if (Math.abs(pos - fromTop) > vh && !force) {
					this.handleScrollBound.lastFromTop = fromTop;
					return;
				}
				
				let posStart = fromTop - (0.1 * vh);
				let posEnd = fromTop + (0.5 * vh);
				this.haqcsOffset = Math.max(0, this.map(pos, posStart, posEnd, 0, 20));

				this.handleScrollBound.lastFromTop = fromTop;
			},
			handleScrollBound: null,

			scrollToTop: function() {
				document.getElementById('frame').scrollTop = 0;
			},

			// language
			// checkLngInterval: -1,
			// checkLng: function() {
			// 	// if(this.$route.path === '/') {
			// 		// setTimeout(() => { this.checkLng() }, 500);
			// 		if (this.language !== this.updateLngLastLng) {
			// 			this.updateLng();
			// 		}
			// 	// }
			// },
			updateLng: function() {
				this.lng = this.messages[this.language];
				// this.updateLngLastLng = this.language;
			},
			// updateLngLastLng: '',
			lng: {},
			messages: {
				en: {
					title: 'Always ventilate properly with smart ventilation',
					description: 'HAQCS is a control system for devices meant to ensure proper air quality and indoor climate. Wireless, needs-based control and regulation of ventilation devices, humidifiers, air conditioners, air cleaners, etc. Without such devices, the HAQCS monitor can monitor the air quality and remind of the ventilation.',

					haqcsIs: 'The HAQCS-Monitor is ...',
					aController: '... a control unit for ventilation and humidification.',
					aMonitor: '... a measuring device for air quality and indoor climate, as well as ...',

					haqcsAsA: 'The HAQCS monitor as a',
					measuringDevice: 'measuring device',
					controller: 'control unit',

					measuringDeviceTopParagraph: 'The HAQCS monitor can be hung on the wall or placed on a desk, bedside table or similar using the pedestal. It then measures the air quality and shows:',

					historyDisplay: "The 'CO<sub>2</sub> history' display shows you the course of the air quality over the last 3 or 12 hours.",
					comfortDisplay: "On the 'comfort' display you can see a comfort scheme on which the current temperature and relative humidity of the room climate is shown.",

					slideText: [
						['How exhausted is the air.', 'Important in workrooms, offices, conference rooms, classrooms – wherever intellectual work and learning, in particular, require good concentration. This decreases from 1500 ppm. A CO<sub>2</sub> sensor makes it possible.'],
						['How polluted is the air.', 'If there are organic substances in the air, that is a sign of pollution. Evaporations from the human body, kitchen odors, cigarette smoke, chemicals from furniture or paints – TVOC (Total Volatile Organic Compounds) are recorded and displayed.'],
						['How good is the indoor climate.', 'People feel comfortable within a certain temperature and humidity window. Insufficient moisture leads to the mucous membranes drying out and ranges from being stressful to being dangerous. Excessive humidity is harmful to the building structure (as it causes mold formation) and therefore also to humans. Measuring the temperature and relative humidity enables the HAQCS monitor to issue warnings.']
					],

					photoTextLED: 'Thanks to the integrated LED display, the air quality can also be viewed when the display is off.',
					photoTextAlarms: 'When certain air quality limits are exceeded, the HAQCS monitor plays alarms so that you know when you should ventilate.',

					controllerTopParagraph: 'The HAQCS monitor can not only issue warnings to remind you to ventilate your room. In conjunction with compatible ventilation units, it can control the ventilation itself. It is then ventilated as required, i.e. always fresh air without unnecessary heat loss. Even ventilation units with heat recovery do not recuperate 100% of the heat, which makes their efficient operation important.',

					explanationModes: 'The HAQCS monitor offers 3 different automatic modes, a manual mode and a night mode in which the ventilation units it controls are particularly quiet.',
					explanationWeighting: 'The automatic control is based on an adjustable weighting from the measured CO<sub>2</sub> and TVOC values.',
					explanationStormMode: 'With the help of the storm mode you can ventilate intensively in a time controlled manner, for example during a work break.',
					explanationSummerMode: 'By activating the summer mode, you can achieve a cooling effect on devices that support this function.',
					explanationHumidityThreshold: 'If the adjustable moisture limit is exceeded, the ventilation is activated automatically to protect the structure of your building.',

					pCompatible: 'Which ventilation units can be made HAQCS-compatible? The system is open, i.e. all manufacturers of ventilation devices, humidifiers, air conditioners, air purifiers, etc. can make their devices HAQCS compatible. The following options are currently available:',
					alnorHRUWALLString: 'Further development of the well-known HRU-WALL-150-60 from the manufacturer Alnor. <br><br>3 operating levels, summer mode, relatively large volume flows from 20 to 60 m³/h. <br><br>In addition to the HAQCS monitor, it can also be controlled with an app.',
					marleyMEnV180String: 'Marley MEnV 180 and upgrade kit <br> <br> The popular Marley MEnV 180 heat recovery ventilation units can be made HAQCS-compatible with a retrofit kit. Retrofitting is limited to replacing the control board and can be performed within 5 minutes.',
					prana150String: 'Prana 150 and upgrade kit <br> <br> The ventilation units with heat recovery Prana 150 and Prana 200 can quickly be made HAQCS compatible by replacing the control board.',
					simpleFans: 'Simple AC fans without heat recovery',
					simpleString: 'Such fans (even those already installed on your site) can be made compatible with the HAQCS-Unibox. The power line to the fan is simply looped through the Unibox to achieve regulated ventilation.',
					and: 'and',

					kickstarter: 'We are soon going to launch our Kickstarter campaign. Stay tuned!',
					kickstarterSupport: 'Support our project!',

					// images: [
					// 	{n: 1, url: "../../static/img/cycle/living-room.jpg", overlay: "../../static/img/cycle/living-room-bubble_en.png"}
					// ],

					// more: 'more',
					// moreTooltip: 'Proceed to: Functionality',

					// pranaTitle: 'Ventilation unit:',
					// pranaSubtitle: 'Innovative Technology',
					// pranaBody: 'The ventilation units PRANA® for the decentralized ventilation of living rooms and other rooms such as offices, smaller stores, coffees or kindergartens up to 120 m² provide constant fresh air and dry walls and windows and help reduce the heating costs during the winter as well as the air conditioning costs during the summer. In most cases, they replace the expensive and maintenance-heavy air handling unit. Inside the stable casing made of ABS plastic, there is a heat exchanger made of copper, quiet fans and the control electronics. The device is meant to be installed into the outer wall of the to-be-ventilated building. It works by exhausting used-up air out of the room and simultaneously supplying fresh, heated air from outside. The two air streams do not mix with each other during this process, during which the heating efficiency reaches 91%. The unit can operate in nine different intensities, which can be specified using a remote control. An important achievement is the lack of a filter, which would destroy ions, which are important for the climate of the room would be biologically populated after a short amount of time, which could lead to health problems. The choice of the material for the heat exchanger (that being copper, which has an antiseptic effect) prevents microorganisms from populating the area on which the air exchange takes place. In case you need a ventilation unit that leads from ventilation ducts to all rooms of a building we also offer ventilation units which are designed for the centralized usage in a building.',

					// solarfoxTitle: 'Solar heating:',
					// solarfoxSubtitle: 'Heating and ventilation at zero cost',
					// solarfoxBody: 'The Solar Fox Air Collector is a modern and technologically advanced solution when it comes to the ventilation, dehumidification, and heating of houses. The device works automatically and does not require to be connected to a power outlet or other installations. Its main functions are to ventilate, heat, and dehumidify your house, your garage, your basement, etc. and, in doing so, help maintain a comfortable climate. The device acts as a minimalistic ventilation unit and heater and is specifically designed to operate all year long.',

					// termofolTitle: 'Infrared Heater:',
					// termofolBody: 'Heating foil is a high-tech heating material with the highest quality standard, which is designed for the heating of floors, ceilings, and walls. The heating elements, which are made of graphite, emit heat waves, that provide a healthy effect on humans. /n/nThe heating foils are predominantly used to heat stores, workshops, warehouses, breeding rooms (terrariums, heating for pets), production rooms, large halls, holiday homes or stand-alone houses, hotels, schools and sports buildings. /n/nThe heating foils may also be used to secure tanks from freezing, eliminate humidity from walls or prevent mirrors from steaming up. Thanks to the innovative solution it is also possible to use the heating foil for the construction of heating panels.',

					// prop1: 'innovative',
					// prop2: 'healthy atmosphere',
					// prop3: 'energy-efficient',

					contact: 'CONTACT',
					areYouInterested: 'Are you interested?',
					contactFormNotice: 'You can also conveniently reach us using our contact form!',
					openContactFormButton: 'open contact form',

					// linkPrana: '/ventilation-unit-functionality-prana',
					// linkSolarfox: '/functionality-solarfox',
					linkContact: '/contact'
				},
				de: {
					title: 'Immer richtig lüften mit intelligent gesteuerten Lüftungsgeräten.',
					description: 'HAQCS ist ein Steuerungssystem für Geräte, die die Luftqualität und das Raumklima sicherstellen. Drahtlose, bedarfsgerechte Steuerung und Regelung von Lüftungsgeräten, Luftbefeuchtern, Klimageräten, Luftreinigern u.ä. Ohne solche Geräte kann der HAQCS-Monitor die Luftqualität überwachen und an die Lüftung erinnern.',

					haqcsIs: 'Der HAQCS-Monitor ist ...',
					aController: '... eine Steuereinheit für Lüftung und Befeuchtung.',
					aMonitor: '... ein Messgerät der Luftqualität und des Raumklimas, sowie ...',

					haqcsAsA: 'Der HAQCS-Monitor als',
					measuringDevice: 'Messgerät',
					controller: 'Steuereinheit',

					measuringDeviceTopParagraph: 'Der HAQCS-Monitor kann sowohl an der Wand aufgehängt, als auch mithilfe des Standfußes auf einem Schreibtisch, einem Nachttisch, oder ähnlichem aufgestellt werden. Daraufhin misst er die Luftqualität und zeigt an:',

					historyDisplay: "Das 'CO<sub>2</sub> history'-Display zeigt Ihnen auf Wunsch den Verlauf der Luftqualität in den letzten 3 oder 12 Stunden.",
					comfortDisplay: "Auf dem 'comfort'-Display können Sie ein Behaglichkeitsschema sehen, auf dem die momentane Temperatur und relative Feuchte des Raumklimas eingezeichnet ist.",

					slideText: [
						['Wie verbraucht ist die Luft.', 'Wichtig in Arbeitsräumen, Büros, Konferenzräumen, Klassenzimmern – überall dort, wo vor allem geistige Arbeit und Lernen eine gute Konzentration erfordern. Diese lässt ab 1500 ppm nach. Ein CO<sub>2</sub>-Sensor macht es möglich.'],
						['Wie verschmutzt ist die Luft.', 'Wenn organische Substanzen in der Luft vorhanden sind, ist das ein Zeichen der Verschmutzung. Ob Ausdunstungen des menschlichen Körpers, Küchengerüche, Zigarettenrauch, Chemikalien aus Möbeln oder Lacken – TVOC (Total Volatile Organic Compounds) werden erfasst und dargestellt.'],
						['Wie gut ist das Raumklima.', 'Der Mensch fühlt sich in einem bestimmten Temperatur- und Feuchtefenster wohl. Zu geringe Feuchte führt zum Austrocknen der Schleimhäute und ist belastend bis gefährlich. Zu hohe Feuchte ist für die Bausubstanz (Schimmelbildung) und dadurch auch für den Menschen schädlich. Die Messung der Temperatur und der relativen Feuchte ermöglicht dem HAQCS-Monitor das Warnen.']
					],

					photoTextLED: 'Dank der LED-Anzeige lässt sich die Luftqualität auch dann einsehen, wenn das Display aus ist.',
					photoTextAlarms: 'Bei der Überschreitung gewisser Grenzen der Luftqualität spielt der HAQCS-Monitor Alarme ab, damit Sie wissen, wann Sie lüften sollten.',

					controllerTopParagraph: 'Der HAQCS-Monitor kann nicht nur warnen um an die Lüftung zu erinnern. In Verbindung mit kompatiblen Lüftungsgeräten kann er das selbst übernehmen. Gelüftet wird dann bedarfsgerecht, d.h. immer ausreichend frische Luft ohne unnötige Wärmeverluste. Auch Lüftungsgeräte mit Wärmerückgewinnung rekuperieren die Wärme nicht zu 100%, wodurch eine energieeffiziente Steuerung wichtig ist.',

					explanationModes: 'Der HAQCS-Monitor bietet 3 verschiedene Automatikmodi, einen manuellen Modus, sowie einen Nachtmodus, in dem die von ihm gesteuerten Lüftungsgeräte besonders laufruhig sind.',
					explanationWeighting: 'Die automatische Reglung richtet sich nach einer einstellbaren Gewichtung aus den gemessenen CO<sub>2</sub>- und TVOC-Werten.',
					explanationStormMode: 'Mithilfe des Sturm-Modus können Sie z.B. während einer Arbeitspause zeitgesteuert intensiv lüften.',
					explanationSummerMode: 'Durch das Aktivieren des Sommermodus können Sie bei Geräten, die diese Funktion unterstützen, einen Kühleffekt erzielen.',
					explanationHumidityThreshold: 'Bei der Überschreitung des einstellbaren Feuchtelimits aktiviert sich die Lüftung automatisch, um die Bausubstanz Ihres Gebäudes zu schützen.',

					pCompatible: 'Welche Lüftungsgeräte können HAQCS-Kompatibel gemacht werden? Das System ist offen, d.h. alle Hersteller von Lüftungsgeräten, Befeuchtern, Klimaanlagen, Luftreinigern u.ä. können ihre Geräte HAQCS-kompatibel machen. Zurzeit bestehen folgende Möglichkeiten: ',
					alnorHRUWALLString: 'Weiterentwicklung des bekannten HRU-WALL-150-60 des Herstellers Alnor. <br><br>3 Betriebsstufen, Sommermodus, relativ große Volumenströme von 20 bis zu 60 m³/h. <br><br>Außer mit dem HAQCS-Monitor, kann alternativ mit einer App gesteuert werden.',
					marleyMEnV180String: 'Marley MEnV 180 und Aufrüstkit <br><br>Die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180 können mit einem Nachrüstkit HAQCS-kompatibel gemacht werden. Das Nachrüsten beschränkt sich auf den Austausch der Steuerplatine und ist in 5 Minuten erledigt.',
					prana150String: 'Prana 150 und Aufrüstkit <br><br>Die Lüftungsgeräte mit Wärmerückgewinnung Prana 150 und Prana 200 lassen sich schnell HAQCS-kompatibel machen. Durch den Austausch der Steuerplatine.',
					simpleFans: 'Einfache Ventilatoren für Wechselstrom ohne Wärmerückgewinnung',
					simpleString: 'Solche Ventilatoren (auch die bereits bei Ihnen montierten) können mit der HAQCS-Unibox kompatibel gemacht werden. Die Stromleitung zum Ventilator wird einfach durch die Unibox durchgeschleift und schon haben Sie eine geregelte Lüftung.',
					and: 'und',

					kickstarter: 'Wir starten bald unsere Kickstarter-Kampagnie!',
					kickstarterSupport: 'Unterstützen Sie uns!',


					// images: [
					// 	{n: 1, url: "../../static/img/cycle/living-room.jpg", overlay: "../../static/img/cycle/living-room-bubble_de.png"}
					// ],

					// more: 'mehr',
					// moreTooltip: 'Weiter zu: Funktionsweise',

					// pranaTitle: 'Lüftungsgerät',
					// pranaSubtitle: 'Innovative Technik',
					// pranaBody: 'Lüftungsgeräte PRANA® für dezentrale Lüftung von Wohnräumen und Räumen wie Büros, kleinere Läden, Kaffes, Kindergärten bis zu 120 m² sorgen für immer frische Luft, trockene Wände und Fenster und sparen die Heizkosten im Winter bzw. Klimatisierungskosten im Sommer. In den meisten Fällen ersetzen sie die teure und aufwändige Lüftungsanlage. In einem stabilen Gehäuse aus ABS befinden sich ein effizienter Wärmetauscher aus Kupfer, leise Ventilatoren und die Steuerelektronik. Das Gerät wird in die Außenwand des zu belüftenden Raumes eingebaut. Es saugt verbrauchte Innenluft aus dem Raum und führt gleichzeitig frische, erwärmte Außenluft zu. Die beiden Luftströme mischen sich dabei nicht. Die Wärmeeffizienz erreicht 91%. Die Intensität der Lüftung kann per Fernbedienung in 9 Stufen eingestellt werden. Eine wichtige Errungenschaft ist, dass auf den Einsatz von Filtern verzichtet werden konnte. Filter zerstören für das Raumklima wichtige Ionen und werden in kurzer Zeit biologisch besiedelt, was oft gefährlich werden kann. Die Materialwahl für den Wärmetauscher (antiseptisch wirkendes Kupfer) führt dazu, dass sich keine Mikroben auf der Austauschfläche ansiedeln. Wird eine Lüftungsanlage benötigt, die aus Lüftungskanälen zu allen Räumen im Gebäude führt, finden Sie hier auch passende Lüftungsgeräte für den zentralen Einsatz.',

					// solarfoxTitle: 'Solarheizung',
					// solarfoxSubtitle: 'Heizen und Lüften zum Null-Tarif',
					// solarfoxBody: 'Solar Fox Air Collector ist eine moderne und technologisch fortschrittliche Lösung der Hauslüftung, Entfeuchtung und Heizung. Das Gerät arbeitet automatisch und benötigt keinen Stromanschluss. Seine Hauptfunktionen sind es, Ihr Haus, Garage, Keller usw. zu belüften, beheizen und zu entfeuchten und so bei der Instandhaltung zu helfen. Das Gerät stellt eine minimalistische Lüftungsanlage mit Heizung dar. Der Solar-Fox-Luftkollektor ist speziell dafür konzipiert, das ganze Jahr über effektiv betrieben zu werden.',

					// termofolTitle: 'Infratorheizung',
					// termofolBody: 'Heizfolie ist ein Hightech-Heizmaterial mit dem höchsten Qualitätsstandard, der für die Beheizung von Fußböden, Decken oder Wänden vorgesehen ist. Die Graphitheizelemente (die den elektrischen Strom leiten) geben Wärmestrahlung ab, die für den Menschen gesundheitsfördernd ist./n/nDie Heizfolien werden vor allem für die Beheizung von Geschäften, Werkstätten, Lagern, Gärtnereien (Treibbeete, Gewächshäuser, Tische für den Anbau von Setzlingen), Zuchträumen (Terrarien, Heizung für Haustiere), Produktionsräumen, großen Hallen, Ferienhäusern und Einfamilienhäusern, Hotels, Schulen, Wohnhäusern, Siedlungen und Sportobjekten verwendet./n/nDie Heizfolien finden auch bei der Sicherung von Tanks gegen Einfrieren, Beseitigung von Feuchtigkeit aus Wänden sowie der Absicherung von Spiegeln gegen Beschlagen Anwendung. Dank der innovativen Lösung ist es möglich, die Heizfolie auch für den Bau von Infrarotpaneelen zu verwenden.',

					// prop1: 'innovativ',
					// prop2: 'gesunde Atmosphäre',
					// prop3: 'spart Energie',

					contact: 'KONTAKT',
					areYouInterested: 'Sind Sie interessiert?',
					contactFormNotice: 'Sie können auch über unser Kontaktformular bequem mit uns Kontakt aufnehmen!',
					openContactFormButton: 'Kontaktformular öffnen',

					// linkPrana: '/lueftungsgeraet-funktionsweise-prana',
					// linkSolarfox: '/funktionsweise-solarfox',
					linkContact: '/kontakt'
				},
				pl: {
					title: 'Zawsze właściwa wentylacja - inteligentne rekuperatory',
					description: 'HAQCS jest systemem bezprzewodowego sterowania i regulacji urządzeń wentylacyjnych, nawilżaczy powietrza, klimatyzacji, itp. Bez takich urządzeń przypomina HAQCS-Monitor o potrzebie wietrzenia, gdy jakość powietrza się pogarsza.',

					haqcsIs: 'Monitor HAQCS jest ...',
					aController: '... jednostką sterującą urządzeń do wentylacji i nawilżania.',
					aMonitor: '... urządzeniem pomiarowym jakości powietrza i klimatu w pomieszczeniu, a także ...',

					haqcsAsA: 'Monitor HAQCS jako',
					measuringDevice: 'urządzenie pomiarowe',
					controller: 'centrum sterowania',

					measuringDeviceTopParagraph: 'Monitor HAQCS można zawiesić na ścianie lub postawić na biurku, szafce nocnej lub podobnym. Mierzy on jakość powietrza i pokazuje:',

					historyDisplay: "‘CO<sub>2</sub>-history’ przedstawia na życzenie przebieg jakości powietrza w ciągu ostatnich 3 lub 12 godzin.",
					comfortDisplay: "‘comfort’ przedstawia aktualną temperaturę i wilgotność na diagramie komfortu klimatycznego.",

					slideText: [
						['Na ile powietrze jest zużyte.', 'Ważne w pracowniach, biurach, salach konferencyjnych, klasach szkolnych - wszędzie tam, gdzie praca intelektualna i nauka wymagają szczególnej koncentracji. Spada ona od 1500 ppm. Umożliwia to czujnik CO<sub>2</sub>.'],
						['Jak zanieczyszczone jest powietrze.', 'Jeśli w powietrzu są substancje organiczne, oznacza to zanieczyszczenie. Emisje ludzkiego ciała, zapachy kuchenne, dym papierosowy, chemikalia z mebli lub farb - TVOC (Total Volatile Organic Compounds) są rejestrowane i wyświetlane.'],
						['Jak dobry jest klimat w pomieszczeniu.', 'Ludzie czują się komfortowo w określonym oknie temperatury i wilgotności. Niewystarczająca wilgotność prowadzi do wysychania błon śluzowych i jest stresująca a nawet niebezpieczna. Nadmierna wilgotność jest szkodliwa dla substancji budowlanej (tworzenie się pleśni), a więc pośrednio także dla ludzi. Pomiar temperatury i wilgotności względnej umożliwia alarmy HAQCS-monitora.']
					],

					photoTextLED: 'Dzięki wyświetlaczowi LED jakość powietrza można również odczytać, gdy ekran jest wyłączony.',
					photoTextAlarms: 'Po przekroczeniu pewnych limitów jakości powietrza HAQCS-monitor alarmuje przypominając o potrzebie wietrzenia.',

					controllerTopParagraph: 'HAQCS-monitor może nie tylko ostrzegać, aby przypominać o wentylacji. W połączeniu z kompatybilnymi urządzeniami wentylacyjnymi może to zrobić sam. Intensywność wentylacji odpowiada zawsze aktualnym potrzebom, tzn. zawsze świeże powietrze bez niepotrzebnych strat ciepła. Nawet urządzenia wentylacyjne z odzyskiem ciepła nie odzyskują go w 100%, więc ważne jest inteligentne sterowanie.',

					explanationModes: 'Monitor HAQCS oferuje 3 różne tryby automatyczne, tryb ręczny i tryb nocny, w którym sterowane jednostki wentylacyjne są szczególnie ciche.',
					explanationWeighting: 'Automatyczna regulacja opiera się na definiowanej przez użytkownika średniej ważonej zmierzonych wartości CO<sub>2</sub> i TVOC.',
					explanationStormMode: 'Za pomocą trybu intensywnego możesz - np. podczas przerwy - intensywnie przez zadany czas wentylować pomieszczenie.',
					explanationSummerMode: 'Aktywując tryb letni, możesz osiągnąć efekt pasywnego chłodzenia jeśli twoje urządzenia obsługują tę funkcję.',
					explanationHumidityThreshold: 'W przypadku przekroczenia ustawionego limitu wilgotności wentylacja włącza się automatycznie w celu ochrony konstrukcji budynku.',

					pCompatible: 'Które jednostki wentylacyjne są lub mogą być kompatybilne z HAQCS? System jest otwarty, tj. wszyscy producenci urządzeń wentylacyjnych, nawilżaczy, klimatyzatorów, oczyszczaczy powietrza itp. mogą dostosować swoje urządzenia do HAQCS. Obecnie dostępne są następujące opcje:',
					alnorHRUWALLString: 'Następca znanego rekuperatora ściennego HRU-WALL-150-60 od producenta Alnor. <br><br>3 poziomy pracy, tryb letni, stosunkowo duże przepływy od 20 do 60 m³/h. <br><br>Oprócz monitora HAQCS można nim również sterować za pomocą aplikacji.',
					marleyMEnV180String: 'Marley MEnV 180 z zestawem aktualizacyjnym<br><br>Popularne urządzenia wentylacyjne z odzyskiem ciepła Marley MEnV 180 mogą stać się kompatybilne z HAQCS za pomocą zestawu modernizacyjnego. Modernizacja ogranicza się do wymiany płytki sterownika i trwa 5 minut.',
					marleyMEnV180IIHAQCSEditionString: 'Następca popularnego modelu Marley MEnV 180 z licznymi udoskonaleniami.<br><br><b>Zalety to:</b> kompatybilność z HAQCS, podwójne filtrowanie powietrza, wszystkie czynnosći obsługowe od wewnątrz budynku, nowoczesna pokrywa wewnętrzna z kolorowym wskażnikiem stopnia wietrzenia.',
					prana150String: 'Prana 150 i 200 z zestawem aktualizacyjnym<br><br>Urządzenia wentylacyjne z odzyskiem ciepła Prana 150 i Prana 200 można szybko dostosować do HAQCS. Przez wymianę płytki sterownika.',
					simpleFans: 'Proste wentylatory do prądu przemiennego bez odzysku ciepła',
					simpleString: 'Takie wentylatory (nawet te już zainstalowane) mogą stać się kompatybilne dzięki HAQCS-Unibox. W przewód zasilania do wentylatora wpina się Unibox i masz regulowaną wentylację.',
					and: 'i',

					kickstarter: 'Wkrótce rozpoczniemy naszą kampanię Kickstarter. Bądźcie czujni!',
					kickstarterSupport: 'Wspieraj nas!',

					// images: [
					// 	{n: 1, url: "../../static/img/cycle/living-room.jpg", overlay: "../../static/img/cycle/living-room-bubble_en.png"}
					// ],

					// more: 'more',
					// moreTooltip: 'Proceed to: Functionality',

					// pranaTitle: 'Ventilation unit:',
					// pranaSubtitle: 'Innovative Technology',
					// pranaBody: 'The ventilation units PRANA® for the decentralized ventilation of living rooms and other rooms such as offices, smaller stores, coffees or kindergartens up to 120 m² provide constant fresh air and dry walls and windows and help reduce the heating costs during the winter as well as the air conditioning costs during the summer. In most cases, they replace the expensive and maintenance-heavy air handling unit. Inside the stable casing made of ABS plastic, there is a heat exchanger made of copper, quiet fans and the control electronics. The device is meant to be installed into the outer wall of the to-be-ventilated building. It works by exhausting used-up air out of the room and simultaneously supplying fresh, heated air from outside. The two air streams do not mix with each other during this process, during which the heating efficiency reaches 91%. The unit can operate in nine different intensities, which can be specified using a remote control. An important achievement is the lack of a filter, which would destroy ions, which are important for the climate of the room would be biologically populated after a short amount of time, which could lead to health problems. The choice of the material for the heat exchanger (that being copper, which has an antiseptic effect) prevents microorganisms from populating the area on which the air exchange takes place. In case you need a ventilation unit that leads from ventilation ducts to all rooms of a building we also offer ventilation units which are designed for the centralized usage in a building.',

					// solarfoxTitle: 'Solar heating:',
					// solarfoxSubtitle: 'Heating and ventilation at zero cost',
					// solarfoxBody: 'The Solar Fox Air Collector is a modern and technologically advanced solution when it comes to the ventilation, dehumidification, and heating of houses. The device works automatically and does not require to be connected to a power outlet or other installations. Its main functions are to ventilate, heat, and dehumidify your house, your garage, your basement, etc. and, in doing so, help maintain a comfortable climate. The device acts as a minimalistic ventilation unit and heater and is specifically designed to operate all year long.',

					// termofolTitle: 'Infrared Heater:',
					// termofolBody: 'Heating foil is a high-tech heating material with the highest quality standard, which is designed for the heating of floors, ceilings, and walls. The heating elements, which are made of graphite, emit heat waves, that provide a healthy effect on humans. /n/nThe heating foils are predominantly used to heat stores, workshops, warehouses, breeding rooms (terrariums, heating for pets), production rooms, large halls, holiday homes or stand-alone houses, hotels, schools and sports buildings. /n/nThe heating foils may also be used to secure tanks from freezing, eliminate humidity from walls or prevent mirrors from steaming up. Thanks to the innovative solution it is also possible to use the heating foil for the construction of heating panels.',

					// prop1: 'innovative',
					// prop2: 'healthy atmosphere',
					// prop3: 'energy-efficient',

					contact: 'CONTACT',
					areYouInterested: 'Jesteś zainteresowany?',
					contactFormNotice: 'Możesz również wygodnie skontaktować się z nami za pomocą naszego formularza kontaktowego!',
					openContactFormButton: 'formularz kontaktowy',

					// linkPrana: '/ventilation-unit-functionality-prana',
					// linkSolarfox: '/functionality-solarfox',
					linkContact: '/kontakt_pl'
				},
			}
		}
	},
	props: [ 'language' ],
	metaInfo() {
		return {
			title: this.lng.title,
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language,
			},
			meta: [
				{ name: 'description', content: this.lng.description },
				{ name: 'theme-color', content: '#00c853' }
			]
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::selection {
	background: #A7F7A6;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}

.spacing-32 {
	padding-top: 32px;
}

#column-content {
  display: inline-block;
}
img {
  vertical-align: middle;
}
span {
  display: inline-block;
  vertical-align: middle;
}

.props {
	padding-top: 16px;

	text-shadow: 1px 3px 4px rgba(0, 0, 0, .4);
	text-align: center;

	/* font-family: "Ubuntu", arial, sans-serif; */
	font-size: 32px;
}

.a-nocolor {
  color: inherit;
  text-decoration: none;
 }

.div-center-124 {
	height: 124px;
	line-height: 124px;
	text-align: center;
}
.div-center-124 .span-center {
	display: inline-block;
	vertical-align: middle;
	line-height: normal;
}

.image-container_ {
	position: relative;
	width: 100%;
	height: 100%;
}
.image-container_ .after {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: block;
	color: #FFF;
}
.image-container_:hover .after {
	display: block;
	background: rgba(0, 0, 0, .005);
}

.viewport-size {
	min-height: 100vh;
    min-width:  100vw;
}

.main-image {
	position: relative;
	width: 80vw;
	max-width: 150vmin;
	height: auto;
	left: 50%;
	transform: translateX(-50%) translateZ(-25vmin);
	z-index: -1;
}

.main-background-image-container_ {
	width:100%;
	height:100%;
	/* filter: blur(0.5vmin); */
	left: 50%;
	transform: translateX(-50%) translateY(240vmax) translateZ(-500vmin) scale(11);
	position: absolute;
	z-index:-3;
	opacity: 0.75;
	overflow: hidden;
}

/* @media screen and (max-width:599px) {
	.main-background-image-container_ {
		display: none;
	}
} */

/* @media screen and (max-aspect-ratio: 1/1) {
	.main-background-image-container_ {
		opacity: 0;
	}
} */

.main-background-image-container_ .main-background-image {
	position: absolute;
	/* width: 100vw; */
	width: 100vmax;
	height: auto;
	/* left: 50%; */
	filter: blur(0.5vmin);
	/* transform: translateX(-50%) translateZ(-50vmin) scale(2.5); */
	z-index: -3;
}

/* small screen */
@media not screen and (min-aspect-ratio: 10/12) {
	.haqcs-is {
		width: 100%;
		/* height: 120vh; */
		background-color:#FFF;
	}

	.haqcs-is .container_ {
		/* position: sticky; */
		/* height: 100vh; */
		width: 100%;

		/* display: flex;
		flex-direction: column; */
	}

	.haqcs-is .container_ .flex-container_ {
		display: flex;
		flex-direction: column;
	}

	.haqcs-is .container_ .content-heading { order: 0; }
	.haqcs-is .container_ .content-as-monitor { order: 1; }
	.haqcs-is .container_ .content-seperator { order: 2; }
	.haqcs-is .container_ .content-as-controller { order: 3; }

	.haqcs-is .container_ .content {
		/* position: absolute; */
		/* top: 50%; */
		/* left: 50%; */
		/* transform: translate(-50%, -50%); */

		/* height: 24vh; */
	}

	.haqcs-is .container_ .content img {
		width: 70%;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}

	.haqcs-is .container_ .content p {
		padding-top: 5vmin;
		font-size: 2.5vmin;
		font-size: max(14px, 2.5vmin);
		padding-left: 12vmin;
		padding-right: 12vmin;
		padding-bottom: 4vmin;
	}

	.haqcs-is .container_ .content .heading {
		color: black;
		font-weight: 100;
		font-size: 3vh;
		font-size: max(14px, 3vh);
		text-shadow: #CCC 1px 0 10px;
		text-align: center;
		padding-top: 12vmin;
		padding-bottom: 6vmin;

		/* transform: translateY(-45vh); */
	}

	.haqcs-is .container_ .content .tile {
		/* transition: 1.7s; */
	}

	.haqcs-is .container_ .content .separator-line {
		height: 0.1vmin;
		min-height: 1px;
		background-color: rgba(0, 0, 0, 0.486);
		width: 80vw;

		display: block;
		margin-left: auto;
		margin-right: auto;

		margin-top: 4vmin;
		margin-bottom: 14vmin;
	}

	.haqcs-is .container_ .both .content .monitor {
		/* transform: translate(0, -20vh); */
	}

	.haqcs-is .container_ .both .content .controller {
		/* transform: translate(0, 20vh); */
	}

	.haqcs-is .container_ .both .content .separator-line {
		/* position: relative;
		left: 0;
		top: 50%;
		transform: translateY(5vmin);

		width: 80vw;
		height: 0.1vmin;
		min-height: 1px;
		background-color: rgba(0, 0, 0, 0.486); */
	}

	.haqcs-is .container_ .single .content .monitor {
		/* transform: translate(0, 0) scale(1.2); */
	}

	.haqcs-is .container_ .single .content .controller {
		/* transform: translate(0, 0) scale(0); */
		/* filter: blur(1vmin); */
	}

	.haqcs-is .container_ .single .content .separator-line {
		/* position: relative;
		left: 0;
		top: 50%;
		transform: translateY(-50%);

		width: 0;
		height: 0.1vmin;
		min-height: 1px;
		background-color: rgba(0, 0, 0, 0.486); */
	}
}

@media screen and (min-aspect-ratio: 10/12) {
	.haqcs-is {
		width: 100%;
		height: 120vh;
		background-color:#FFF;
	}

	.haqcs-is .container_ {
		position: sticky;
		height: 100vh;
		width: 100%;
	}

	.haqcs-is .container_ .content {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		width: 24vw;
	}

	.haqcs-is .container_ .content img {
		width: 100%;
	}

	.haqcs-is .container_ .content p {
		padding-top: 2.7vmin;
		font-size: 2.5vmin;
		font-size: max(13px, 2.5vmin);
		text-align: center;
		min-height: 15vh;
	}

	.haqcs-is .container_ .content .heading {
		color: black;
		font-weight: 100;
		font-size: 3vh;
		font-size: max(19px, 3vh);
		text-shadow: #CCC 1px 0 10px;
		text-align: center;
		padding-top: 19.4vh;

		transform: translateY(-48vh);
	}

	.haqcs-is .container_ .content .tile {
		transition: 1.7s;
	}

	.haqcs-is .container_ .both .content .monitor {
		transform: translate(-20vw, 0);
	}

	.haqcs-is .container_ .both .content .controller {
		transform: translate(20vw, 0);
	}

	.haqcs-is .container_ .both .content .separator-line {
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);

		height: 50vh;
		width: 0.1vmin;
		min-width: 1px;
		background-color: rgba(0, 0, 0, 0.486);
	}

	.haqcs-is .container_ .single .content .monitor {
		transform: translate(0, 0) scale(1.2);
	}

	.haqcs-is .container_ .single .content .controller {
		transform: translate(0, 0) scale(0);
		filter: blur(1vmin);
	}

	.haqcs-is .container_ .single .content .separator-line {
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);

		height: 0;
		width: 0.1vmin;
		min-width: 1px;
		background-color: rgba(0, 0, 0, 0.486);
	}
}

#haqcs-as-a-monitor {
	margin: 0;
}

@media (max-width: 1023px) {
	.header-bar {
		position: relative;
		transition: 0.5s;
		z-index: 10;
		backdrop-filter: blur(1vmin);
	}

	.header-bar-sticking {
		background-color: rgb(253, 253, 253, 0.854901961);
	}

	.header-bar-not-sticking {
		background-color: rgb(253, 253, 253, 0.854901961);
	}
}

@media (min-width: 1024px) {
	.header-bar {
		position: sticky;
		z-index: 513;
		backdrop-filter: blur(1vmin);
		transition: 0.5s;
	}

	.header-bar-sticking {
		background-color: rgb(241, 241, 241, 0.854901961);
	}

	.header-bar-not-sticking {
		background-color: rgb(253, 253, 253, 0.854901961);
	}
}

.header-bar .header-bar-container_ {
	padding: 2vmin 10vmin;
	margin: 0;
}

.header-bar .header-bar-container_ .top-heading {
	color: black;
	font-weight: 500;
	font-size: 3vmin;
	font-size: max(16px, min(38px, 3.5vmin));
	text-align: left;
}

.header-bar .header-bar-container_ .top-heading-item {
	/* margin-left: 1vmin; */
	cursor: pointer;
	transition: color 0.25s;
}

.header-bar .header-bar-container_ .top-heading-inactive {
	color: rgba(0, 0, 0, 0.35);
	font-weight: 500;
	font-size: 3vmin;
	font-size: max(16px, min(38px, 3.5vmin));
	text-align: left;
}

.header-bar .header-bar-container_ .top-heading-inactive:hover {
	color: rgba(0, 0, 0, 0.7);
	font-size: 3vmin;
	font-size: max(16px, min(38px, 3.5vmin));
	text-align: left;
}

@media (max-width: 1023px) {
	.header-bar .header-bar-container_ .top-paragraph {
		color: black;
		font-weight: 400;
		font-size: 3vmin;
		font-size: max(14px, 3vmin);
		text-align: left;
		margin-bottom: 8vmin;
	}
}

@media (min-width: 1024px) {
	.header-bar .header-bar-container_ .top-paragraph {
		color: black;
		font-weight: 400;
		font-size: 2vmin;
		text-align: left;
		margin-bottom: 0;
	}
}

.header-bar .shadow {
	height: 0.5vmin;
	width: 100%;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.0));
	position: absolute;
	bottom: -0.5vmin;
	transition: opacity 0.5s;
}

@media (max-width: 1023px) {
	.header-bar .shadow-visible {
		opacity: 0.0;
	}
}

@media (min-width: 1024px) {
	.header-bar .shadow-visible {
		opacity: 1.0;
	}
}

.header-bar .shadow-invisible {
	opacity: 0.0;
}

#haqcs-as-a-monitor {
	background-color: rgb(253, 253, 253);
	/* height: 300vh; */
	display: flex;
	flex-direction: column;
}

#haqcs-as-a-monitor .vertical-dots-container_ {
	height: 100vh;
	width: 10vmin;
	position: sticky;
	left: 0;
	text-align: center;
	z-index: 3;

	/* background:#A7F7A6; */
}

#haqcs-as-a-monitor .vertical-dots-container_ .centered-dots-container_ {
	width: 100%;
	
	position: absolute;
	top: 50%;
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
}

#haqcs-as-a-monitor .vertical-dots-container_ .centered-dots-container_ .single-dot-container_ {
	/* background: rgba(0, 0, 0, 0.2); */
	padding-top: 1vmin;
	padding-bottom: 1vmin;

	cursor: pointer;
	opacity: 0.2;
	transition: 0.3s;
}

#haqcs-as-a-monitor .vertical-dots-container_ .centered-dots-container_ .single-dot-container_:hover {
	opacity: 0.7;
}

#haqcs-as-a-monitor .vertical-dots-container_ .centered-dots-container_ .single-dot-container_-active {
	opacity: 0.85;
}

#haqcs-as-a-monitor .vertical-dots-container_ .centered-dots-container_ .single-dot-container_ .dot {
	background: rgba(0, 0, 0, 1.0);
	width: 2.0vmin;
	height: 2.0vmin;
	border-radius: 2.0vmin;
	width: max(14px, 2.0vmin);
	height: max(14px, 2.0vmin);
	border-radius: max(14px, 2.0vmin);
	transition: 0.2s;
}

#haqcs-as-a-monitor .vertical-dots-container_ .centered-dots-container_ .single-dot-container_ .dot-inactive {
	-moz-transform: scale(0.8);
	-webkit-transform: scale(0.8);
	-o-transform: scale(0.8);
	-ms-transform: scale(0.8);
	transform: scale(0.8);
}

@media not screen and (min-width: 1024px) {
	#haqcs-as-a-monitor .slide {
		z-index: 0;
		position: relative;
		/* height: 40vh; */
		padding-top: 1vh;
		padding-bottom: 1vh;
		width: 100vw;
		/* background-color: #A7F7A6; */
		/* margin-top: 50%;
		margin-bottom: 50%; */
	}

	#haqcs-as-a-monitor .slide0 { order: 0; }
	#haqcs-as-a-monitor .slide1 { order: 1; }
	#haqcs-as-a-monitor .slide2 { order: 2; }
	#haqcs-as-a-monitor .slide3 { order: 3; }

	#haqcs-as-a-monitor .haqcs-display {
		/* height: 55vh; */
		height: 100%;
		width: 100vw;
		position: sticky;
		margin-left: 0vw;

		bottom: 0;
		top: unset;

		z-index: 2;

		order: 4;

		/* padding-top: 20vh; */
		
		/* background-color: rgb(204, 159, 101); */

		transition: 0.1s;
	}

	#haqcs-as-a-monitor .haqcs-display .container_ {
		width: 100%;
		max-width: 1024px;
		height: 100%;
		position: relative;
		/* top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%); */

		background:rgba(218, 218, 218, 0.644);
		backdrop-filter: blur(1vmin);		
	}

	#haqcs-as-a-monitor .haqcs-display .container_ .img-container_ {
		height: 85.468%;

		position: relative;

		display: inline-block;
		left: 50%;
		transform: translateX(-50%);
	}

	/* @media not screen and (min-aspect-ratio: 8/12) {
		#haqcs-as-a-monitor .haqcs-display .container_ img {
			max-width: 80vw;
			max-height: 45vh;
			display: block;
			margin-left: auto;
			margin-right: auto;

			opacity: 1.0;
			position: absolute;

			transition: 0.5s;
		}

		#haqcs-as-a-monitor .haqcs-display .container_ .inactive {
			opacity: 0;
		}
	} */

	/* @media screen and (min-aspect-ratio: 8/12) { */
		#haqcs-as-a-monitor .haqcs-display .container_ img {
			max-width: 80vw;
			max-height: 45vh;
			/* max-height: 80%; */
			display: block;
			margin-left: auto;
			margin-right: auto;
			/* padding-top: 20vh;
			padding-bottom: 2vh; */

			opacity: 1.0;
			position: absolute;

			transform: translateY(1.5vmin);

			transition: 0.5s;
		}

		#haqcs-as-a-monitor .haqcs-display .container_ .inactive {
			opacity: 0;
		}
	/* } */

	#haqcs-as-a-monitor .haqcs-display .container_ p {
		position: relative;
		transition: 0.5s;

		color: black;
		font-weight: 400;
		font-size: 3vmin;
		font-size: max(14px, 3vmin);
		text-align: left;
		margin-bottom: 0;
		padding-bottom: 1vmin;
		padding-left: 10vw;
		padding-right: 5vw;
	}

	#haqcs-as-a-monitor .haqcs-display .container_ .invisible {
		opacity: 0;
	}
}

@media screen and (min-width: 1024px) {
	#haqcs-as-a-monitor .slide {
		z-index: 0;
		position: relative;
		height: 100vh;
		width: 50vw;
		perspective: 10px;
		/* background-color: #A7F7A6; */
		/* margin-top: 50%;
		margin-bottom: 50%; */
	}

	#haqcs-as-a-monitor .slide0 { order: 1; }
	#haqcs-as-a-monitor .slide1 { order: 2; }
	#haqcs-as-a-monitor .slide2 { order: 3; }
	#haqcs-as-a-monitor .slide3 { order: 4; }

	#haqcs-as-a-monitor .haqcs-display {
		height: 100vh;
		width: 50vw;
		position: sticky;
		margin-left: 50vw;

		padding-top: 20vh;

		order: 0;

		transition: opacity 0.5s;
		
		/* background-color: rgb(204, 159, 101); */
	}

	#haqcs-as-a-monitor .haqcs-display .container_ {
		width: 100%;
		position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%);
	}

	#haqcs-as-a-monitor .haqcs-display .container_ .img-container_ {
		height: 85.468%;

		position: relative;

		display: inline-block;
		left: 50%;
		transform: translateX(-50%);
	}

	#haqcs-as-a-monitor .haqcs-display .container_ img {
		max-width: 35vw;
		max-height: 60vh;
		display: block;
		margin-left: auto;
		margin-right: auto;
		/* padding-top: 20vh;
		padding-bottom: 2vh; */
		z-index: 0;

		opacity: 1.0;
		position: absolute;

		transition: 0.5s;
	}

	#haqcs-as-a-monitor .haqcs-display .container_ .inactive {
		opacity: 0;
	}

	#haqcs-as-a-monitor .haqcs-display .container_ p {
		position: absolute;
		transition: 0.5s;

		color: black;
		font-weight: 400;
		font-size: 2vmin;
		text-align: left;
		margin-bottom: 0;

		margin-right: 2vw;
	}

	#haqcs-as-a-monitor .haqcs-display .container_ .invisible {
		opacity: 0;	
	}
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector {
	/* background-color: aquamarine; */
	height: 5vh;
	text-align: center;
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector span {
	cursor: pointer;
	transition: 0.3s;
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector .bead {
	width: 2.5vmin;
	height: 2.5vmin;
	width: max(18px, 2.5vmin);
	height: max(18px, 2.5vmin);
	/* background-color:rgb(1, 61, 117); */
	border-radius: 2.5vmin;
	border-radius: max(18px, 2.5vmin);
	margin-left: 1vmin;
	margin-right: 1vmin;
	padding: 0;
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector .active .bead {
	box-shadow: 0 0.2vmin 0.2vmin rgba(0, 0, 0, 0.5);
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector .inactive {
	opacity: 0.5;
	box-shadow: 0 0 0 rgba(0, 0, 0, 0.0);

	-moz-transform: scale(0.8);
	-webkit-transform: scale(0.8);
	-o-transform: scale(0.8);
	-ms-transform: scale(0.8);
	transform: scale(0.8);
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector .inactive:hover {
	opacity: 0.8;
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector .shiny {
	width: 2.5vmin;
	height: 2.5vmin;
	width: max(18px, 2.5vmin);
	height: max(18px, 2.5vmin);

	border-radius: 2.5vmin;
	border-radius: max(18px, 2.5vmin);

	-moz-transform: scale(0.5) translate(-0.8vmin, -0.8vmin);
	-webkit-transform: scale(0.5) translate(-0.8vmin, -0.8vmin);
	-o-transform: scale(0.5) translate(-0.8vmin, -0.8vmin);
	-ms-transform: scale(0.5) translate(-0.8vmin, -0.8vmin);
	transform: scale(0.5) translate(-0.8vmin, -0.8vmin);

	background-image: linear-gradient(to bottom right, rgba(255, 255, 255, 0.62), rgba(255, 255, 255, 0.0));
	/* border-radius: 3vmin; */
	/* margin-left: 1vmin; */
	/* margin-right: 1vmin; */
	margin-top: 0;
	margin-right: 0;
	margin-bottom: 0;
	margin-left: 0;

	position: absolue;

	opacity: 0.5;
}

#haqcs-as-a-monitor .haqcs-display .container_ .color-selector .invisible {
	opacity: 0;
}

@media (max-width: 1023px) {
	#haqcs-as-a-monitor .slide .text {
		/* position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%); */

		padding: 10vmin;

		color: rgb(0, 0, 0);
		font-size: 3vmin;
		font-size: max(14px, 3vmin);
	}
}

@media (min-width: 1024px) {
	#haqcs-as-a-monitor .slide .text {
		position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%);

		padding: 10vmin;

		color: rgb(0, 0, 0);
		font-size: 2.6vmin;
		font-size: min(28px, 2.6vmin);

		transition: transform 4.5s;
	}

	#haqcs-as-a-monitor .slide .text-not-viewed {
		position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%) translateZ(-0.5px);
		transform: translateY(-50%) translateZ(-0.5px);

		padding: 10vmin;

		color: rgb(0, 0, 0);
		font-size: 2.6vmin;
		font-size: min(28px, 2.6vmin);
	}
}

@media (max-width: 1023px) {
	#haqcs-as-a-monitor .img-slide {
		height: 100vh;
		position: relative;

		background-color: rgb(240, 239, 243);
	}

	#haqcs-as-a-monitor .img-slide .text-container_ {
		position: absolute;
		height: 100%;
		width: 100vw;
		left: 0;

		/* background-color: rgba(255, 0, 0, 0.5); */
	}

	#haqcs-as-a-monitor .img-slide .text-container_ .text {
		color: rgb(0, 0, 0);
		color: rgba(0, 0, 0, .9);
		padding: 15vmin;
		font-weight: 300;
		font-size: 3.5vmin;
		font-size: max(16px, min(38px, 3.5vmin));
		text-shadow: rgb(226, 226, 226) 1px 0 10px;
		text-align: left;
		word-wrap: break-word;

		position: absolute;
		top: 30%;
		-ms-transform: translateY(-50%) translateZ(10vmin);
		transform: translateY(-50%) translateZ(10vmin);
	}

	@media screen and (min-aspect-ratio: 1/1) {
		#haqcs-as-a-monitor .img-slide .text-container_ .text {
			top: 25%;
		}
	}

	#haqcs-as-a-monitor .img-slide-dark .text-container_ .text {
		color: rgb(255, 255, 255);
		color: rgba(255, 255, 255, .9);
		text-shadow: rgb(27, 27, 27) 1px 0 10px;
	}

	#haqcs-as-a-monitor .img-slide .text-container_ .small-image {
		background-color: white;
		/* padding: 3vmin; */
		box-shadow: 0 0.25vmin 0.5vmin rgba(0, 0, 0, 0.38);

		max-width: 67%;
		max-height: 55%;

		position: relative;
		top: 60%;
		left: 50%;
		-ms-transform: translateY(-50%) translateX(-50%) translateZ(15vmin) scale(0.8);
		transform: translateY(-50%) translateX(-50%) translateZ(15vmin) scale(0.8);
	}

	#haqcs-as-a-monitor .img-slide .text-background {
		position: absolute;
		height: 100%;
		width: 100vw;
		left: 0;

		background-color: rgba(240, 239, 243, 0.6);

		backdrop-filter: blur(2.5vmin);
	}

	#haqcs-as-a-monitor .img-slide-dark .text-background {
		background-color: rgba(21, 34, 53, 0.6);
	}

	#haqcs-as-a-monitor .img-slide .text-background-fade {
		position: absolute;
		height: 100%;
		width: 0vw;
		left: 30vw;

		/* background-color: rgba(255, 0, 0, 0.5); */
		/* background-color: rgb(240, 239, 243); */
		background: linear-gradient(to right, rgba(240, 239, 243, 1.0), rgba(240, 239, 243, 0.0));
	}

	#haqcs-as-a-monitor .img-slide .img {
		position: absolute;
		height: 100%;
		width: 100vw;
		right: 0;
		/* background-color: rgba(0, 0, 255, 0.5); */
	}
}

@media (min-width: 1024px) {
	#haqcs-as-a-monitor .img-slide {
		height: 80vh;
		position: relative;

		background-color: rgb(240, 239, 243);
	}

	#haqcs-as-a-monitor .img-slide-dark {
		background-color: rgb(21, 34, 53);
	}

	#haqcs-as-a-monitor .img-slide .text-container_ {
		position: absolute;
		height: 100%;
		width: 55vw;
		left: 0;

		/* background-color: rgba(255, 0, 0, 0.5); */
	}

	#haqcs-as-a-monitor .img-slide .text-container_ .text {
		color: rgb(0, 0, 0);
		color: rgba(0, 0, 0, .9);
		padding: 5vmin;
		font-weight: 300;
		font-size: 3.5vmin;
		text-shadow: rgb(226, 226, 226) 1px 0 10px;
		text-align: left;
		word-wrap: break-word;

		position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%) translateZ(10vmin) scale(0.8);
		transform: translateY(-50%) translateZ(10vmin) scale(0.8);
	}

	#haqcs-as-a-monitor .img-slide-dark .text-container_ .text {
		color: rgb(255, 255, 255);
		color: rgba(255, 255, 255, .9);
		text-shadow: rgb(27, 27, 27) 1px 0 10px;
	}

	#haqcs-as-a-monitor .img-slide .text-background {
		position: absolute;
		height: 100%;
		width: 30vw;
		left: 0;

		background-color: rgb(240, 239, 243);
	}

	#haqcs-as-a-monitor .img-slide-dark .text-background {
		background-color: rgb(21, 34, 53);
	}

	#haqcs-as-a-monitor .img-slide .text-background-fade {
		position: absolute;
		height: 100%;
		width: 25vw;
		left: 30vw;

		/* background-color: rgba(255, 0, 0, 0.5); */
		/* background-color: rgb(240, 239, 243); */
		background: linear-gradient(to right, rgba(240, 239, 243, 1.0), rgba(240, 239, 243, 0.0));
	}

	#haqcs-as-a-monitor .img-slide-dark .text-background-fade {
		background: linear-gradient(to right, rgba(21, 34, 53, 1.0), rgba(21, 34, 53, 0.0));
	}

	#haqcs-as-a-monitor .img-slide .img {
		position: absolute;
		height: 100%;
		width: 70vw;
		right: 0;

		/* background-color: rgba(0, 0, 255, 0.5); */
	}
}

#haqcs-as-a-controller .image-of-haqcs {
	height: 100vmin;
	width: 100%;
	text-align: center;
	background-color: rgb(250, 250, 250);
}

#haqcs-as-a-controller .image-of-haqcs .haqcs {
	position: absolute;
	margin-top: 30vmin;
	left: 50%;
	transform: translateX(-50%) translateZ(10vmin);

	/* width: 20vw; */
	width: 40vmin;

	/* background:#CCC; */
}

#haqcs-as-a-controller .image-of-haqcs .dev-2 {
	position: absolute;
	margin-top: 30vmin;
	left: 25%;
	transform: translateX(-50%) translateZ(22vmin);

	width: 20vw;

	/* background:#CCC; */
}

#haqcs-as-a-controller .image-of-haqcs .dev-1 {
	position: absolute;
	margin-top: 30vmin;
	right: 10%;
	transform: translateX(-50%) translateZ(26vmin);

	width: 20vw;

	/* background:#CCC; */
}

#haqcs-as-a-controller .image-of-haqcs .dev0 {
	position: absolute;
	margin-top: 10vmin;
	left: 20%;
	transform: translateX(-50%) translateZ(5vmin);

	width: 12vw;

	/* background:#CCC; */
}

#haqcs-as-a-controller .image-of-haqcs .dev1 {
	position: absolute;
	margin-top: 15vmin;
	left: 42%;
	transform: translateX(-50%) translateZ(-10vmin);

	width: 12vw;

	/* background:#CCC; */
}

#haqcs-as-a-controller .image-of-haqcs .dev2 {
	position: absolute;
	margin-top: 5vmin;
	left: 67%;
	transform: translateX(-50%) translateZ(-30vmin);

	width: 12vw;

	/* background:#CCC; */
}

#haqcs-as-a-controller .image-of-haqcs .dev3 {
	position: absolute;
	margin-top: 60vmin;
	left: 34%;
	transform: translateX(-50%) translateZ(15vmin);

	width: 12vw;

	/* background:#CCC; */
}

#haqcs-as-a-controller .image-of-haqcs .dev4 {
	position: absolute;
	margin-top: 56vmin;
	left: 70%;
	transform: translateX(-50%) translateZ(30vmin);

	width: 12vw;

	/* background:#CCC; */
}

#haqcs-as-a-controller .paragraph-container_ {
	padding: 5vmin 10vmin;
	background-color: rgb(255, 255, 255);
}

@media (max-width: 1023px) {
	#haqcs-as-a-controller .paragraph-container_ .paragraph {
		font-size: 3vmin;
		font-size: max(14px, 3vmin);
		color: black;
	}
}

@media (min-width: 1024px) {
	#haqcs-as-a-controller .paragraph-container_ .paragraph {
		font-size: 2.3vmin;
		color: black;
	}
}

@media (max-width:1023px) {
	#haqcs-as-a-controller .paragraph-container_ .paragraph .flex-container_ {
		display: flex;
		flex-direction: column;
	}

	#haqcs-as-a-controller .paragraph-container_ .paragraph .flex-container_ img {
		order: 0;

		position: relative;
		left: 50%;
		transform: translateX(-50%);
		/* box-shadow: 0 0.3vmin 1vmin rgba(0, 0, 0, 0.25); */
		/* width: 70vw; */
		width: 100%;
		margin-bottom: 5vmin;
	}

	#haqcs-as-a-controller .paragraph-container_ .paragraph .flex-container_ p {
		order: 1;

		/* padding-left: 5vmin; */
	}
}

@media (min-width:1024px) {
	#haqcs-as-a-controller .paragraph-container_ .paragraph .flex-container_ {
		display: flex;
		flex-direction: row;
	}

	#haqcs-as-a-controller .paragraph-container_ .paragraph .flex-container_ img {
		order: 0;

		position: relative;
		left: 50%;
		transform: translateX(-50%);
		/* box-shadow: 0 0.3vmin 1vmin rgba(0, 0, 0, 0.25); */
		width: 30vw;
	}

	#haqcs-as-a-controller .paragraph-container_ .paragraph .flex-container_ p {
		order: 1;

		padding-left: 5vmin;
	}
}

#haqcs-as-a-controller .paragraph-container_ .spacer {
	margin-bottom: 10vmin;
}

#haqcs-as-a-controller .explanation {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	padding: 5vmin;

	font-size: 2.3vmin;
	font-size: max(14px, 2.3vmin);
	color: black;

	background-color: rgb(253, 253, 253);
}

#haqcs-as-a-controller .explanation .tile {
	padding: 1.0vmin;
}

@media not screen and (min-width: 1024px) {
	#haqcs-as-a-controller .explanation .tile {
		width: 100%;
	}
}

@media screen and (min-width: 1024px) {
	#haqcs-as-a-controller .explanation .tile {
		width: 50%;
	}
}

#haqcs-as-a-controller .explanation .tile .tile-content {
	background-color: rgb(245, 245, 245);
	border-radius: .5vmin;
	padding: 2.0vmin;
	box-shadow: 0 0.25vmin 0.5vmin rgba(0, 0, 0, 0.07);
	overflow: hidden;
	height: 100%;
}

#haqcs-as-a-controller .explanation .tile .bg-icon {
	position: absolute;
	height: 15vmin;
	padding: 1vmin;
	opacity: .066;
	/* left: 0; */
}

#haqcs-as-a-controller .explanation .tile .tile-content .center {
	position: relative;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

#haqcs-as-a-controller .explanation .container_ {
	display: flex;
	justify-content: space-around;
	padding: 0;
	margin: 0;
	width: 100%;
}

#haqcs-as-a-controller .explanation .container_ .text {
	order: 0;
	width: 50%;
	flex-grow: 1;
}

#haqcs-as-a-controller .explanation .container_ .text p {
	position: relative;
	top: 50%;
	transform: translateY(-50%);
}

#haqcs-as-a-controller .explanation .container_ .images {
	order: 1;
	max-width: 50%;
	min-width: 30%;
	flex-grow: 1;

	padding-left: 2vmin;
}

#haqcs-as-a-controller .explanation .container_ .images img {
	position: relative;
	width: 100%;
	display: block;

	box-shadow: 0 0.25vmin 0.5vmin rgba(0, 0, 0, 0.5);
}

#haqcs-as-a-controller .explanation .container_ .images .no-shadow {
	box-shadow: 0 0 0 rgba(0, 0, 0, 0);
}

#haqcs-as-a-controller .explanation .tile0 {
	order: 0;
	width: 100%;
}

#haqcs-as-a-controller .explanation .tile0 .container_ .images .img0 {
	transform: translateX(0%) scale(1.0);
	z-index: 5;
	opacity: 1.0;
	margin-bottom: 0.50vmin;
}
#haqcs-as-a-controller .explanation .tile0 .container_ .images .img1 {
	transform: translateX(2.5%) scale(0.95);
	z-index: 4;
	opacity: 0.9;
	margin-bottom: 0.40vmin;
}
#haqcs-as-a-controller .explanation .tile0 .container_ .images .img2 {
	transform: translateX(5%) scale(0.90);
	z-index: 3;
	opacity: 0.8;
	margin-bottom: 0.30vmin;
}
#haqcs-as-a-controller .explanation .tile0 .container_ .images .img3 {
	transform: translateX(7.5%) scale(0.85);
	z-index: 2;
	opacity: 0.7;
	margin-bottom: 0.20vmin;
}
#haqcs-as-a-controller .explanation .tile0 .container_ .images .img4 {
	transform: translateX(10%) scale(0.80);
	z-index: 1;
	opacity: 0.6;
	margin-bottom: 0.10vmin;
}

#haqcs-as-a-controller .explanation .tile1 {
	order: 1
}

#haqcs-as-a-controller .explanation .tile2 {
	order: 2
}

#haqcs-as-a-controller .explanation .tile3 {
	order: 3
}

#haqcs-as-a-controller .explanation .tile4 {
	order: 4
}

.kickstarter {
	width: 90vmin;
	border-radius: 3vmin;
	/* border-style: solid; */
	/* border-width: 0.8vmin; */
	/* border-color: rgb(1, 156, 118); */
	padding: 4vmin;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	margin: 15vmin 0;
	background-color: rgba(255, 255, 255, 1.0);
	box-shadow: 0 0.3vmin 2.5vmin rgba(0, 0, 0, 0.5);

	color: rgba(0, 0, 0, 0.9);
	font-size: 2.7vmin;
}

.kickstarter .button {
	min-height: 2vmin;
	border-radius: 3vmin;
	/* background-color: rgb(1, 156, 118); */
	background-color: rgba(128, 128, 128, 0.38);

	padding: 1vmin;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 5vmin;
	text-align: center;
	color: white;
	font-weight: bold;
	text-transform: uppercase;
	/* cursor: pointer; */
	cursor: not-allowed;

	transition: 0.3s;
}

/* .kickstarter .button:hover {
	background-color: rgb(0, 187, 140);
	box-shadow: 0 0.3vmin 1vmin rgba(0, 0, 0, 0.35);
} */

.haqcs-heading-1 {
	color: black;
	font-weight: 700;
	letter-spacing: 1.8vh;
	padding-left: 1.8vh;
	text-shadow: #CCC 1px 0 10px;
	text-align: center;
	padding-top: 6.5vmax;
	font-size: 11.5vmin;
	font-size: max(53px, 11.5vmin);

	transform: translateZ(10vmin) scale(0.95);
}

.haqcs-heading-2 {
	color: black;
	font-weight: 100;
	font-size: 3vmin;
	font-size: max(14px, 3vmin);
	text-shadow: #CCC 1px 0 10px;
	text-align: center;

	transform: translateZ(5vmin) scale(0.98);
}

.haqcs-heading-3 {
	color: black;
	font-weight: 100;
	font-size: 3vh;
	text-shadow: #CCC 1px 0 10px;
	text-align: center;
	padding-top: 19.4vh;
}

@media (min-width: 1024px) {
	.haqcs-heading-4 {
		color: rgb(255, 255, 255);
		color: rgba(255, 255, 255, .9);
		font-weight: 700;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 5vh;
		text-shadow: #000 1px 0 10px;
		text-align: left;
		padding-top: 8vh;
	}

	.haqcs-heading-5 {
		color: rgb(0, 0, 0);
		color: rgba(0, 0, 0, .9);
		font-weight: 700;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 5vh;
		text-shadow: rgb(226, 226, 226) 1px 0 10px;
		text-align: left;
		padding-top: 8vh;
	}

	.haqcs-heading-4-text {
		color: rgb(255, 255, 255);
		color: rgba(255, 255, 255, .9);
		font-weight: 100;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 4.5vh;
		text-shadow: #000 1px 0 10px;
		text-align: left;
		word-wrap: break-word;
		padding-top: 8vh;
	}

	.haqcs-heading-5-text {
		color: rgb(0, 0, 0);
		color: rgba(0, 0, 0, .9);
		font-weight: 100;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 4.5vh;
		text-shadow: rgb(226, 226, 226) 1px 0 10px;
		text-align: left;
		word-wrap: break-word;
		padding-top: 8vh;
	}

	.text-over-button-card-img-container_ {
		position: absolute;
		width: 70vw;
	}
}

@media (max-width: 1023px) {
	.haqcs-heading-4 {
		color: rgb(255, 255, 255);
		color: rgba(255, 255, 255, .9);
		font-weight: 700;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 5vw;
		text-shadow: #000 1px 0 10px;
		text-align: left;
		padding-top: 8vw;
	}

	.haqcs-heading-5 {
		color: rgb(0, 0, 0);
		color: rgba(0, 0, 0, .9);
		font-weight: 700;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 5vw;
		text-shadow: rgb(226, 226, 226) 1px 0 10px;
		text-align: left;
		padding-top: 8vw;
	}

	.haqcs-heading-4-text {
		color: rgb(255, 255, 255);
		color: rgba(255, 255, 255, .9);
		font-weight: 100;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 4.5vw;
		text-shadow: #000 1px 0 10px;
		text-align: left;
		word-wrap: break-word;
		padding-top: 8vw;
	}

	.haqcs-heading-5-text {
		color: rgb(0, 0, 0);
		color: rgba(0, 0, 0, .9);
		font-weight: 100;
		padding-left: 10vh;
		padding-right: 10vh;
		font-size: 4.5vw;
		text-shadow: rgb(226, 226, 226) 1px 0 10px;
		text-align: left;
		word-wrap: break-word;
		padding-top: 8vw;
	}

	.text-over-button-card-img-container_ {
		position: absolute;
		width: 90vw;
	}
}

.carousell-learn-more-button-container_ {
	width: 100%;
	text-align: center;
	padding-top: 5vh;
	padding-left: 10vh;
	padding-right: 10vh;

	/* background-color: rgba(0, 255, 255, 0.671); */
}

.carousell-learn-more-button-container_ .button {
	min-width: 20vmax;
	padding: 0.7vmax 5vmax;
	text-transform: uppercase;
	font-weight: bold;
	border-radius: 100vmax;
	border-style: solid;
	border-width: 0.1vmax;
	-webkit-transition: background-color 0.1s linear;
    -ms-transition: background-color 0.1s linear;
    transition: background-color 0.1s linear;
	cursor: pointer;
}

.carousell-learn-more-button-container_ .button-light {
	background-color: rgba(255, 255, 255, 0.103);
	color: white;
	border-color: rgba(255, 255, 255, 0.658);
	text-shadow: 0px 2px 3px rgba(0, 0, 0);
	box-shadow: 0px 2px 3px rgba(0, 0, 0);
	text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.507);
	box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.336);
}

.carousell-learn-more-button-container_ .button-dark {
	background-color: rgba(144, 166, 207, 0.103);
	color: rgb(1, 61, 117);
	border-color: rgba(7, 76, 156, 0.658);
	text-shadow: 0px 2px 3px rgba(0, 0, 0);
	box-shadow: 0px 2px 3px rgba(0, 0, 0);
	text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.199);
	box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.336);
}

@media (min-width: 1600px) {
	.carousell-learn-more-button-container_ .button-font-size {
		font-size: 1vmax;
	}
}

@media (max-width: 1599px) {
	.carousell-learn-more-button-container_ .button-font-size {
		font-size: 1.5rem;
	}
}

.carousell-learn-more-button-container_ .button:hover {
	background-color: rgba(255, 255, 255, 0.267);
}

.carousell-learn-more-button-container_ .button:active {
	background-color: rgba(255, 255, 255, 0.637);
}

.button-container_ {
	width: 52vw;
	/* max-width: 1024px; */
	margin: 0 auto;
	padding-top: 2vh;
}

.button-container_ .separator-container_ {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 50%;
	padding-bottom: 50%;
}

.button-container_ .separator-container_ img {
	width: 7vh;
}

.button-card {
	background-color: rgb(73, 106, 145);
	color: rgb(255, 255, 255);
	color: rgba(255, 255, 255, 0.95);
	text-transform: uppercase;
	font-weight: 700;
	font-size: 1.2em;
	border-radius: 0.5vh;
	overflow: hidden;
	height: 100%;
	min-height: 23vh;
}

.button-card-img {
	border-radius: 0;
	float: right;
	right: 0;
	position: absolute;
	z-index: 0;
	opacity: .9;

	width: 100%;
	height: 100%;
	object-fit: cover;
	overflow: hidden;
}

.button-card .text {
	font-size: 2.9vh;
	padding: 2.5vh;
	position: relative;
	z-index: 1;
	text-shadow: #000 1px 0 10px;
}

.text-over-button-card-img {
	position: relative;
	z-index: 0;
}

.carousell-icon-container_ {
	position: absolute;
	width: 100%;
	height: 100vh;
}

.carousell-icon-container_ .slim-container_ {
	z-index: 1;
	top: 0;
	bottom: 0;
	width: 9vh;

	position: absolute;

	cursor: pointer;
	transition: 0.2s;
}

.carousell-icon-container_ .slim-container_-left {
	left: 0
}

.carousell-icon-container_ .slim-container_-right {
	right: 0
}

.carousell-icon-container_ .slim-container_-bright {
	background-color: rgb(255, 255, 255, 0);
}

.carousell-icon-container_ .slim-container_-bright:hover {
	background-color: rgb(255, 255, 255, 0.25);
}

.carousell-icon-container_ .slim-container_-dark {
	background-color: rgb(0, 0, 0, 0);
}

.carousell-icon-container_ .slim-container_-dark:hover {
	background-color: rgb(0, 0, 0, 0.25);
}

.carousell-icon-container_ .slim-container_ .carousell-icon {
	position: absolute;
	z-index: 1;
	top: 50%;
	bottom: 50%;
	font-size: 4vh;
	cursor: pointer;
	text-shadow: 0 1px 5px rgb(0, 0, 0, 0.5);
}

.carousell-icon-container_ .slim-container_-disabled {
	cursor: default;
}

.carousell-icon-container_ .slim-container_ .carousell-icon-left {
	left: 2.5vh;
}

.carousell-icon-container_ .slim-container_ .carousell-icon-right {
	right: 2.5vh;
}

.carousell-icon-container_ .slim-container_ .carousell-icon-clickable {
	opacity: 1.0;
	cursor: pointer;
}

.carousell-icon-container_ .slim-container_ .carousell-icon-disabled {
	opacity: 0.35;
	cursor: default;
}

.carousell-bottom-bar-container_ {
	position: absolute;
	height: 100vh;
	width: 100%;
}

.carousell-bottom-bar {
	position: absolute;
	bottom: 0;
	z-index: 1;
	/* height: 5vh; */
	padding-bottom: 4vh;
	width: 100%;
	text-align: center;

	/* background:rgba(167, 247, 166, 0.315); */
}

.carousell-bottom-bar .dot-container_ {
	width: 4.0vmax;
	height: 2.0vmax;

	cursor: pointer;

	transition: opacity .5s;

	/* background-color:rgba(177, 113, 113, 0.808); */
}

.carousell-bottom-bar .dot-container_-inactive {
	opacity: 0.45;
}

.carousell-bottom-bar .dot-container_-active {
	opacity: 1.0;
}

.carousell-bottom-bar .dot-container_:hover {
	opacity: 0.9;
}

.carousell-bottom-bar .dot-container_ .dot {
	width: 0.8vmax;
	height: 0.8vmax;
	border-radius: 0.4vmax;
	transition: 0.3s;
}

.carousell-bottom-bar .dot-container_-active .dot {
	transform: scale(1.5);
}

.carousell-bottom-bar .dot-container_ .dot-light {
	background-color: white;
	box-shadow: 0 0.2vmin 0.3vmax rgb(0, 0, 0);
	box-shadow: 0 0.2vmin 0.3vmax rgb(0, 0, 0, 0.5);
}

.carousell-bottom-bar .dot-container_ .dot-dark {
	background-color: rgb(255, 255, 255);
	box-shadow: 0 0.2vmin 0.3vmax rgb(0, 0, 0);
	box-shadow: 0 0.2vmin 0.3vmax rgb(0, 0, 0, 0.8);
	/* border-style: solid;
	border-width: 0.2vmin;
	border-color: rgb(119, 119, 119); */
}

.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.slide-fade-right-enter-active {
	transition: all 1s cubic-bezier(.77,-0.09,.23,1.34);
}
.slide-fade-right-leave-active {
	transition: all .1s ease;
}
.slide-fade-right-enter {
	transform: translateX(40px);
	opacity: 0;
}
.slide-fade-right-leave-to {
	transform: translateX(10px);
	opacity: 0;
}

.slide-fade-left-enter-active {
	transition: all 1s cubic-bezier(.77,-0.09,.23,1.34);
}
.slide-fade-left-leave-active {
	transition: all .1s ease;
}
.slide-fade-left-enter {
	transform: translateX(-40px);
	opacity: 0;
}
.slide-fade-left-leave-to {
	transform: translateX(-10px);
	opacity: 0;
}

.slide-fade-left-slow-enter-active {
	transition: all 1.5s cubic-bezier(.77,-0.09,.23,1.34);
}
.slide-fade-left-slow-leave-active {
	transition: all .1s ease;
}
.slide-fade-left-slow-enter {
	transform: translateX(-40px);
	opacity: 0;
}
.slide-fade-left-slow-leave-to {
	transform: translateX(-10px);
	opacity: 0;
}

.slide-fade-left-slower-enter-active {
	transition: all 2s cubic-bezier(.77,-0.09,.23,1.34);
}
.slide-fade-left-slower-leave-active {
	transition: all .1s ease;
}
.slide-fade-left-slower-enter {
	transform: translateX(-40px);
	opacity: 0;
}
.slide-fade-left-slower-leave-to {
	transform: translateX(-10px);
	opacity: 0;
}

.slide-fade-left-even-slower-enter-active {
	transition: all 2.5s cubic-bezier(.77,-0.09,.23,1.34);
}
.slide-fade-left-even-slower-leave-active {
	transition: all .1s ease;
}
.slide-fade-left-even-slower-enter {
	transform: translateX(-50px);
	opacity: 0;
}
.slide-fade-left-even-slower-leave-to {
	transform: translateX(-10px);
	opacity: 0;
}

.slide-animation-enter-active {
	transition: all 1s cubic-bezier(.14,1.54,.53,1.02);
}
.slide-animation-leave-active {
	transition: all .1s ease;
}
.slide-animation-enter {
	transform: translateY(1vh);
	opacity: 0;
}
.slide-animation-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Home.vue?7a062178